import React, { useMemo, useEffect, useCallback, useState, useContext, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker as DatePicker$1, TimePicker as TimePicker$1, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import axios from 'axios';
import { useFormikContext, Form, Formik } from 'formik';
import { makeStyles, TextField, Grid, Typography, Box, FormControlLabel, Checkbox, IconButton, FormGroup, withStyles, Slider, MenuItem, Input as Input$1, useTheme, Radio, FormControl, RadioGroup, Link as Link$1, AppBar, Tabs, Tab, Hidden, Drawer, Button, Toolbar, Stepper, Step, StepLabel, StepContent, Container } from '@material-ui/core';
import classnames from 'classnames';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash.throttle';
import { InfoOutlined } from '@material-ui/icons';
import format$1 from 'date-fns/format';
import { isBefore, isAfter, addMinutes, parse as parse$1, getDay, roundToNearestMinutes, differenceInMinutes, isSameDay, format, addDays } from 'date-fns';
import NumberFormat from 'react-number-format';
import InputMask from 'react-input-mask';
import { makeStyles as makeStyles$1, withStyles as withStyles$1, useTheme as useTheme$1, createMuiTheme } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import Typography$1 from '@material-ui/core/Typography';
import Link$2 from '@material-ui/core/Link';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import flatten from 'lodash.flatten';
import { object, number, string } from 'yup';
import 'yup-phone';
import Cookies from 'js-cookie';
import TagManager from 'react-gtm-module';
import merge from 'lodash.merge';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var ADDRESS_AUTOCOMPLETE = 'address-autocomplete';
var CHECKBOX = 'Checkbox';
var DATEPICKER = 'date picker';
var HIDDEN = 'hidden';
var RADIO = 'Radio';
var RADIO_WITH_ICONS = 'Radio with Icons';
var SINGLE_SELECT_DROPDOWN = 'Single-Select Dropdown';
var SLIDER = 'slider';
var TELEPHONE = 'tel';
var TIMEPICKER = 'time picker';
var options = {
  ADDRESS_AUTOCOMPLETE: ADDRESS_AUTOCOMPLETE,
  CHECKBOX: CHECKBOX,
  DATEPICKER: DATEPICKER,
  HIDDEN: HIDDEN,
  RADIO: RADIO,
  RADIO_WITH_ICONS: RADIO_WITH_ICONS,
  SINGLE_SELECT_DROPDOWN: SINGLE_SELECT_DROPDOWN,
  SLIDER: SLIDER,
  TELEPHONE: TELEPHONE,
  TIMEPICKER: TIMEPICKER
};

var GOOGLE_MAPS = 'AIzaSyDT-3qu8a1Fm9rhnbLiB9LeGLJTm8-DTuU';
var apiKeys = {
  GOOGLE_MAPS: GOOGLE_MAPS
};

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  var script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

var processPlace = function processPlace(placeData) {
  return placeData.reduce(function (newFields, curr) {
    var _curr$types, _curr$types2, _curr$types3, _curr$types4, _curr$types5, _curr$types6;

    if ((_curr$types = curr.types) !== null && _curr$types !== void 0 && _curr$types.includes('street_number')) {
      newFields.streetLine1 = curr.long_name + newFields.streetLine1;
    } else if ((_curr$types2 = curr.types) !== null && _curr$types2 !== void 0 && _curr$types2.includes('route')) {
      newFields.streetLine1 += " ".concat(curr.long_name);
    } else if ((_curr$types3 = curr.types) !== null && _curr$types3 !== void 0 && _curr$types3.includes('locality')) {
      newFields.city = curr.long_name;
    } else if ((_curr$types4 = curr.types) !== null && _curr$types4 !== void 0 && _curr$types4.includes('administrative_area_level_1')) {
      newFields.state = curr.short_name;
    } else if ((_curr$types5 = curr.types) !== null && _curr$types5 !== void 0 && _curr$types5.includes('administrative_area_level_2')) {
      newFields.county = curr.long_name;
    } else if ((_curr$types6 = curr.types) !== null && _curr$types6 !== void 0 && _curr$types6.includes('postal_code')) {
      newFields.zip = curr.long_name;
    }

    return newFields;
  }, {
    streetLine1: '',
    city: '',
    state: '',
    county: '',
    zip: ''
  });
};

// sizes based around fonts, but can be used for spacing
var SIZE = {
  s100: 8,
  s200: 12,
  s300: 14,
  s400: 15,
  s500: 16,
  s600: 18,
  s700: 20,
  s800: 22,
  s900: 24,
  s1000: 32
};
var SIZE$1 = Object.freeze(SIZE);

var autocompleteService = {
  current: null
};
var placeService = {
  current: null
};
var useStyles$t = makeStyles(function (_ref) {
  var _palette$addressAutoc, _typography$addressAu, _typography$addressAu2, _palette$addressAutoc2, _palette$addressAutoc3, _palette$addressAutoc4;

  var palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    icon: {
      color: palette === null || palette === void 0 ? void 0 : (_palette$addressAutoc = palette.addressAutocomplete) === null || _palette$addressAutoc === void 0 ? void 0 : _palette$addressAutoc.icon,
      marginRight: spacing(2)
    },
    label: {
      fontFamily: typography === null || typography === void 0 ? void 0 : (_typography$addressAu = typography.addressAutocompleteLabel) === null || _typography$addressAu === void 0 ? void 0 : _typography$addressAu.fontFamily,
      fontSize: SIZE$1.s700,
      fontWeight: typography === null || typography === void 0 ? void 0 : (_typography$addressAu2 = typography.addressAutocompleteLabel) === null || _typography$addressAu2 === void 0 ? void 0 : _typography$addressAu2.fontWeight
    },
    option: {
      color: palette === null || palette === void 0 ? void 0 : (_palette$addressAutoc2 = palette.addressAutocomplete) === null || _palette$addressAutoc2 === void 0 ? void 0 : _palette$addressAutoc2.body2
    },
    root: {
      '& legend': {
        fontSize: SIZE$1.s500
      },
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$addressAutoc3 = palette.addressAutocomplete) === null || _palette$addressAutoc3 === void 0 ? void 0 : _palette$addressAutoc3.border,
        borderWidth: 2
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$addressAutoc4 = palette.addressAutocomplete) === null || _palette$addressAutoc4 === void 0 ? void 0 : _palette$addressAutoc4.border
      }
    }
  };
});
function GoogleMaps(props) {
  var classes = useStyles$t();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      inputValue = _React$useState4[0],
      setInputValue = _React$useState4[1];

  var _React$useState5 = React.useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      options = _React$useState6[0],
      setOptions = _React$useState6[1];

  var loaded = React.useRef(false);

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      handleBlur = _useFormikContext.handleBlur,
      setFieldValue = _useFormikContext.setFieldValue,
      touched = _useFormikContext.touched;

  if (typeof document !== 'undefined' && !loaded.current) {
    if (!document.querySelector('#google-maps')) {
      loadScript('https://maps.googleapis.com/maps/api/js?key=' + apiKeys.GOOGLE_MAPS + '&libraries=places', document.querySelector('head'), 'google-maps');
    }

    loaded.current = true;
  }

  var fetch = useMemo(function () {
    return throttle(function (request, callback) {
      autocompleteService.current.getPlacePredictions(request, callback);
    }, 200);
  }, []);
  useEffect(function () {
    var active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
      placeService.current = new window.google.maps.places.PlacesService(document.querySelector('#google-maps'));
    }

    if (!autocompleteService.current || !placeService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({
      input: inputValue,
      componentRestrictions: {
        country: ['us', 'pr']
      }
    }, function (results) {
      if (active) {
        var newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [].concat(_toConsumableArray(newOptions), _toConsumableArray(results));
        }

        setOptions(newOptions);
      }
    });
    return function () {
      active = false;
    };
  }, [value, inputValue, fetch]);
  var handlePlaceSelected = useCallback(function (address) {
    if (!address) return;
    placeService.current.getDetails({
      placeId: address.place_id,
      fields: ['address_components']
    }, function (results, status) {
      if (status === 'OK') {
        var newAddress = processPlace(results.address_components);
        setFieldValue('street', newAddress.streetLine1);
        setFieldValue('city', newAddress.city);
        setFieldValue('state', newAddress.state);
        setFieldValue('zip', newAddress.zip);
      }
    });
  }, [setFieldValue]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: "google-map-demo",
    style: {
      width: '100%'
    },
    getOptionLabel: function getOptionLabel(option) {
      return typeof option === 'string' ? option : option.description;
    },
    filterOptions: function filterOptions(x) {
      return x;
    },
    options: options,
    autoComplete: true,
    includeInputInList: true,
    filterSelectedOptions: true,
    value: value,
    onChange: function onChange(event, newValue) {
      setOptions(newValue ? [newValue].concat(_toConsumableArray(options)) : options);
      setValue(newValue);
      setFieldValue('address', (newValue === null || newValue === void 0 ? void 0 : newValue.description) || '');
      handlePlaceSelected(newValue);
    },
    onInputChange: function onInputChange(event, newInputValue) {
      setInputValue(newInputValue);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        className: classes.root,
        error: touched.address && errors.address ? true : null,
        fullWidth: true,
        helperText: touched.address && errors.address ? errors.address : null,
        InputLabelProps: {
          className: classes.label,
          shrink: true
        },
        id: "address",
        label: "Address",
        name: "address",
        onBlur: handleBlur,
        required: true,
        variant: "outlined"
      }));
    },
    renderOption: function renderOption(option) {
      var matches = option.structured_formatting.main_text_matched_substrings;
      var parts = parse(option.structured_formatting.main_text, matches.map(function (match) {
        return [match.offset, match.offset + match.length];
      }));
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(LocationOnIcon, {
        className: classes.icon
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: true
      }, parts.map(function (part, index) {
        return /*#__PURE__*/React.createElement("span", {
          key: index,
          style: {
            fontWeight: part.highlight ? 700 : 400
          }
        }, part.text);
      }), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        className: classes.option
      }, option.structured_formatting.secondary_text)));
    }
  });
}

var checkedIcon = function checkedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "15",
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 1L6 12L1 7",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var useStyles$s = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      display: 'flex'
    },
    icon: {
      fontSize: 60,
      position: 'absolute',
      top: SIZE$1.s500
    },
    bypass: {
      border: 0
    },
    Box: {
      borderColor: function borderColor(_ref2) {
        var _palette$checkboxButt, _palette$checkboxButt2, _palette$checkboxButt3, _palette$checkboxButt4;

        var checked = _ref2.checked,
            isActive = _ref2.isActive;
        return checked || isActive ? palette === null || palette === void 0 ? void 0 : (_palette$checkboxButt = palette.checkboxButton) === null || _palette$checkboxButt === void 0 ? void 0 : (_palette$checkboxButt2 = _palette$checkboxButt.border) === null || _palette$checkboxButt2 === void 0 ? void 0 : _palette$checkboxButt2.checked : palette === null || palette === void 0 ? void 0 : (_palette$checkboxButt3 = palette.checkboxButton) === null || _palette$checkboxButt3 === void 0 ? void 0 : (_palette$checkboxButt4 = _palette$checkboxButt3.border) === null || _palette$checkboxButt4 === void 0 ? void 0 : _palette$checkboxButt4.unchecked;
      }
    },
    FormControlLabel: {
      backgroundColor: function backgroundColor(_ref3) {
        var _palette$checkboxButt5;

        var checked = _ref3.checked,
            isActive = _ref3.isActive,
            isBypass = _ref3.isBypass;
        return (checked || isActive) && !isBypass ? palette === null || palette === void 0 ? void 0 : (_palette$checkboxButt5 = palette.checkboxButton) === null || _palette$checkboxButt5 === void 0 ? void 0 : _palette$checkboxButt5.background : 'transparent';
      },
      borderColor: function borderColor(_ref4) {
        var _palette$checkboxButt6, _palette$checkboxButt7, _palette$checkboxButt8, _palette$checkboxButt9;

        var checked = _ref4.checked,
            isActive = _ref4.isActive,
            isBypass = _ref4.isBypass;
        return (checked || isActive) && !isBypass ? palette === null || palette === void 0 ? void 0 : (_palette$checkboxButt6 = palette.checkboxButton) === null || _palette$checkboxButt6 === void 0 ? void 0 : (_palette$checkboxButt7 = _palette$checkboxButt6.border) === null || _palette$checkboxButt7 === void 0 ? void 0 : _palette$checkboxButt7.checked : palette === null || palette === void 0 ? void 0 : (_palette$checkboxButt8 = palette.checkboxButton) === null || _palette$checkboxButt8 === void 0 ? void 0 : (_palette$checkboxButt9 = _palette$checkboxButt8.border) === null || _palette$checkboxButt9 === void 0 ? void 0 : _palette$checkboxButt9.unchecked;
      },
      borderBottomWidth: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0,
      borderStyle: 'solid',
      borderTopWidth: function borderTopWidth(_ref5) {
        var isAllOrNone = _ref5.isAllOrNone,
            isBypass = _ref5.isBypass;
        return isAllOrNone || isBypass ? 0 : 1;
      },
      color: function color(_ref6) {
        var _palette$checkboxButt10, _palette$checkboxButt11, _palette$checkboxButt12, _palette$checkboxButt13;

        var checked = _ref6.checked,
            isActive = _ref6.isActive,
            isBypass = _ref6.isBypass;
        return (checked || isActive) && !isBypass ? palette === null || palette === void 0 ? void 0 : (_palette$checkboxButt10 = palette.checkboxButton) === null || _palette$checkboxButt10 === void 0 ? void 0 : (_palette$checkboxButt11 = _palette$checkboxButt10.text) === null || _palette$checkboxButt11 === void 0 ? void 0 : _palette$checkboxButt11.checked : palette === null || palette === void 0 ? void 0 : (_palette$checkboxButt12 = palette.checkboxButton) === null || _palette$checkboxButt12 === void 0 ? void 0 : (_palette$checkboxButt13 = _palette$checkboxButt12.text) === null || _palette$checkboxButt13 === void 0 ? void 0 : _palette$checkboxButt13.unchecked;
      },
      height: '37px',
      justifyContent: function justifyContent(_ref7) {
        var isBypass = _ref7.isBypass;
        return isBypass ? 'flex-start' : 'space-between';
      },
      padding: function padding(_ref8) {
        var isBypass = _ref8.isBypass;
        return isBypass ? 0 : '0 2px 0 10px';
      },
      margin: 0,
      whiteSpace: 'nowrap',
      width: '100%'
    }
  };
});

var CheckboxButton = function CheckboxButton(_ref9) {
  var checked = _ref9.checked,
      handleClick = _ref9.handleClick,
      icon = _ref9.icon,
      isBypass = _ref9.isBypass,
      label = _ref9.label,
      value = _ref9.value;
  var isAllOrNone = value === 'All' || value === 'None';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var classes = useStyles$s({
    checked: checked,
    isActive: isActive,
    isAllOrNone: isAllOrNone,
    isBypass: isBypass
  });
  var onClick = useCallback(function (e) {
    // prevent event bubbling, so handleClick is only called once
    e.preventDefault();
    handleClick(value);
    setActive(false);
  }, [handleClick, value]);
  return /*#__PURE__*/React.createElement(Box, {
    alignItems: "flex-end",
    border: checked || isActive ? 2 : 1,
    display: "flex",
    height: isAllOrNone || isBypass ? 39 : 128,
    justifyContent: "center",
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      setActive(false);
    },
    position: "relative",
    className: isBypass ? classes.bypass : classes.Box
  }, !isAllOrNone && icon && /*#__PURE__*/React.createElement("img", {
    src: icon[0].src,
    alt: icon[0].title,
    className: classes.icon,
    width: 75,
    height: 75
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.FormControlLabel,
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: checked,
      disableRipple: true,
      value: value,
      checkedIcon: isBypass ? undefined : /*#__PURE__*/React.createElement(checkedIcon, null)
    }),
    label: label,
    labelPlacement: isBypass ? 'end' : 'start'
  }));
};

CheckboxButton.propTypes = {
  checked: PropTypes.bool,
  handleClick: PropTypes.func,
  icon: PropTypes.any,
  isBypass: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string.isRequired
};
CheckboxButton.defaultProps = {
  checked: false,
  handleClick: function handleClick() {},
  icon: null,
  label: '',
  value: ''
};

var SectionLabel = function SectionLabel(_ref) {
  var info = _ref.info;
      _ref.infoIcon;
      var label = _ref.label,
      openInfoDrawer = _ref.openInfoDrawer,
      required = _ref.required;
  if (!label) return null;
  return /*#__PURE__*/React.createElement(Typography, {
    gutterBottom: true,
    variant: "h4"
  }, label, ' ', required && /*#__PURE__*/React.createElement("sup", null, "*"), info && /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      openInfoDrawer(info);
    }
  }, /*#__PURE__*/React.createElement(InfoOutlined, {
    style: {
      fontSize: 20
    }
  })));
};

SectionLabel.propTypes = {
  info: PropTypes.string,
  infoIcon: PropTypes.object,
  label: PropTypes.string,
  openInfoDrawer: PropTypes.func,
  required: PropTypes.bool
};

var ALL = 'All';
var NONE = 'None';

var filteredCheckBoxValues = function filteredCheckBoxValues(options) {
  return options.map(function (item) {
    return item.fields.value;
  }).filter(function (val) {
    return val !== NONE;
  });
};

var CheckboxOptions = function CheckboxOptions(_ref) {
  var doNotProceedContent = _ref.doNotProceedContent,
      doNotProceedValues = _ref.doNotProceedValues,
      info = _ref.info,
      infoIcon = _ref.infoIcon,
      input = _ref.input,
      isBypass = _ref.isBypass,
      openInfoDrawer = _ref.openInfoDrawer,
      sectionLabel = _ref.sectionLabel;
  var _input$fields = input.fields,
      isRequired = _input$fields.isRequired,
      label = _input$fields.label,
      name = _input$fields.name,
      options = _input$fields.options;

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      setFieldValue = _useFormikContext.setFieldValue,
      touched = _useFormikContext.touched,
      values = _useFormikContext.values;

  var handleClick = useCallback(function (value) {
    var _values$name;

    if (doNotProceedValues !== null && doNotProceedValues !== void 0 && doNotProceedValues.includes(value)) {
      openInfoDrawer(doNotProceedContent, true);
      return;
    } // Deselecting


    if ((_values$name = values[name]) !== null && _values$name !== void 0 && _values$name.includes(value)) {
      if (value === ALL) {
        setFieldValue(name, []);
      } else {
        // Otherwise deselect selected checkbox and 'All' if selected
        var filteredItems = values[name].filter(function (val) {
          return val !== value && val !== ALL;
        });
        setFieldValue(name, filteredItems);
      }
    } // Selecting
    else {
        if (value === ALL) {
          setFieldValue(name, filteredCheckBoxValues(options));
        } else if (value === NONE) {
          setFieldValue(name, [NONE]);
        } else {
          var _values$name2;

          // Select individual checkbox & deselect 'None'
          var filterOutNone = ((_values$name2 = values[name]) === null || _values$name2 === void 0 ? void 0 : _values$name2.filter(function (val) {
            return val !== NONE;
          })) || [];
          setFieldValue(name, [].concat(_toConsumableArray(filterOutNone), [value]));
        }
      }
  }, [doNotProceedValues, values, name, openInfoDrawer, doNotProceedContent, setFieldValue, options]);
  var margins = {
    mb: isBypass ? {
      xs: 3
    } : {
      xs: 6,
      md: 12
    },
    mt: isBypass ? {
      xs: 0
    } : {
      xs: 3,
      md: 6
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionLabel, {
    info: info,
    infoIcon: infoIcon,
    label: sectionLabel || label,
    openInfoDrawer: openInfoDrawer,
    required: isRequired
  }), !isBypass && /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Select all that apply"), touched[name] && errors[name] && /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, errors[name]), /*#__PURE__*/React.createElement(Box, {
    mb: margins.mb,
    mt: margins.mt
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: isBypass ? 'flex-start' : 'center',
    spacing: 2
  }, options === null || options === void 0 ? void 0 : options.map(function (item) {
    var _item$sys, _item$fields, _item$fields2, _item$fields3, _values$name3, _item$fields4;

    return /*#__PURE__*/React.createElement(Grid, {
      xs: 6,
      item: true,
      key: item === null || item === void 0 ? void 0 : (_item$sys = item.sys) === null || _item$sys === void 0 ? void 0 : _item$sys.id
    }, /*#__PURE__*/React.createElement(CheckboxButton, {
      label: item === null || item === void 0 ? void 0 : (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.label,
      value: item === null || item === void 0 ? void 0 : (_item$fields2 = item.fields) === null || _item$fields2 === void 0 ? void 0 : _item$fields2.value,
      icon: item === null || item === void 0 ? void 0 : (_item$fields3 = item.fields) === null || _item$fields3 === void 0 ? void 0 : _item$fields3.icon,
      name: name,
      handleClick: handleClick,
      checked: (_values$name3 = values[name]) === null || _values$name3 === void 0 ? void 0 : _values$name3.includes(item === null || item === void 0 ? void 0 : (_item$fields4 = item.fields) === null || _item$fields4 === void 0 ? void 0 : _item$fields4.value),
      isBypass: isBypass
    }));
  })))));
};

CheckboxOptions.propTypes = {
  doNotProceedContent: PropTypes.string,
  doNotProceedValues: PropTypes.array,
  info: PropTypes.string,
  infoIcon: PropTypes.object,
  input: PropTypes.object,
  isBypass: PropTypes.bool,
  openInfoDrawer: PropTypes.func,
  sectionLabel: PropTypes.string
};
CheckboxOptions.defaultProps = {
  input: {},
  isBypass: false,
  openInfoDrawer: function openInfoDrawer() {},
  doNotProceedValues: [],
  doNotProceedContent: ''
};

var weekDaysHours = '5am - 7pm';
var saturdayHours = '6am - 7pm';
var sundayHours = '7am - 4pm';

var DATE_FORMAT = 'MM/dd/yyyy';
var TIME_FORMAT = 'HH:mm';
var DEFAULT_CALL_TIME = '10:30';
var isValidDateTime = function isValidDateTime(date, time) {
  var today = new Date();
  var parsedTime = Boolean(time) && parse$1(time, TIME_FORMAT, today);
  var dayOfWeek = getDayOfWeek(date);
  var hours = '';

  if (dayOfWeek === 0) {
    hours = sundayHours;
  } else if (dayOfWeek === 6) {
    hours = saturdayHours;
  } else {
    hours = weekDaysHours;
  }

  var _hours$split$map = hours.split(' - ').map(function (hour) {
    return parse$1(hour, 'hha', today);
  }),
      _hours$split$map2 = _slicedToArray(_hours$split$map, 2),
      minHour = _hours$split$map2[0],
      maxHour = _hours$split$map2[1];

  return parsedTime && !isBefore(parsedTime, minHour) && !isAfter(parsedTime, maxHour);
};
var getNextTimeForToday = function getNextTimeForToday() {
  var now = new Date();
  var roundedTime = roundToNearestMinutes(now, {
    nearestTo: 15
  });
  var difference = differenceInMinutes(roundedTime, now);
  return addMinutes(roundedTime, difference < 0 ? 30 : 15);
};
var isValidTimeToday = function isValidTimeToday(date, time) {
  var today = new Date();
  var parsedTime = Boolean(time) && parse$1(time, TIME_FORMAT, today) || today;
  var parsedDate = Boolean(date) && parse$1(date, DATE_FORMAT, today);

  if (isSameDay(parsedDate, today) && isBefore(parsedTime, getNextTimeForToday())) {
    return false;
  }

  return true;
};

var getDayOfWeek = function getDayOfWeek(date) {
  return getDay(parse$1(date, DATE_FORMAT, new Date()));
};

var getHelperTextForDay = function getHelperTextForDay(date) {
  var dayOfWeek = getDayOfWeek(date);

  if (dayOfWeek === 0) {
    return "Sunday: ".concat(sundayHours, " PST");
  } else if (dayOfWeek === 6) {
    return "Saturday: ".concat(saturdayHours, " PST");
  } else {
    return "Mon - Fri: ".concat(weekDaysHours, " PST");
  }
};
var getFutureContactDateTime = function getFutureContactDateTime(day, time) {
  var today = new Date();
  var formattedToday = format(today, DATE_FORMAT, new Date());
  var scheduleTime = time || DEFAULT_CALL_TIME;
  var scheduleDay = day;

  if (!Boolean(day) && !Boolean(time)) {
    return null;
  }

  if (!Boolean(day)) {
    var callToday = isValidTimeToday(formattedToday, time);
    scheduleDay = callToday ? formattedToday : format(addDays(today, 1), DATE_FORMAT, today);
  }

  return parse$1("".concat(scheduleDay, "-").concat(scheduleTime), "".concat(DATE_FORMAT, "-").concat(TIME_FORMAT), new Date()).toISOString();
};

var useStyles$r = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      '& .MuiFormLabel-root.Mui-disabled': {
        color: "".concat(palette.text.disabled, " !important")
      },
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: function borderColor(_ref2) {
          var _palette$input;

          var disabled = _ref2.disabled;
          return !disabled && (palette === null || palette === void 0 ? void 0 : (_palette$input = palette.input) === null || _palette$input === void 0 ? void 0 : _palette$input.border);
        },
        borderWidth: '2px'
      },
      '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: function borderColor(_ref3) {
          var _palette$input2;

          var disabled = _ref3.disabled;
          return !disabled && (palette === null || palette === void 0 ? void 0 : (_palette$input2 = palette.input) === null || _palette$input2 === void 0 ? void 0 : _palette$input2.border);
        }
      }
    }
  };
});
var timeName = 'scheduleCallTime'; // Time picker name from contentful

var DatePicker = function DatePicker(_ref4) {
  var disabled = _ref4.disabled,
      input = _ref4.input;
  var _input$fields = input.fields,
      label = _input$fields.label,
      name = _input$fields.name;
  var classes = useStyles$r({
    disabled: disabled
  });

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue,
      values = _useFormikContext.values;

  var handleChange = useCallback(function (e) {
    setFieldValue(name, format$1(e, DATE_FORMAT));
    setFieldValue(timeName, null);
  }, [name, setFieldValue]);
  var dateValue = useMemo(function () {
    return Boolean(values[name]) ? values[name] : null;
  }, [name, values]);
  return /*#__PURE__*/React.createElement(DatePicker$1, {
    autoOk: true,
    className: classes.root,
    disabled: disabled,
    disablePast: true,
    disableToolbar: true,
    format: DATE_FORMAT,
    id: name,
    inputVariant: "outlined",
    label: label,
    onChange: handleChange,
    value: dateValue,
    variant: "inline"
  });
};

DatePicker.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.object
};

var CustomizedSlider = withStyles({
  root: {
    width: '100%'
  }
})(Slider);

function DiscreteSlider(_ref) {
  var info = _ref.info,
      infoIcon = _ref.infoIcon,
      input = _ref.input,
      openInfoDrawer = _ref.openInfoDrawer;
  var _input$fields = input.fields,
      _input$fields$default = _input$fields.defaultValue,
      defaultValue = _input$fields$default === void 0 ? '400' : _input$fields$default,
      _input$fields$format = _input$fields.format,
      format = _input$fields$format === void 0 ? '$[[value]]' : _input$fields$format,
      isRequired = _input$fields.isRequired,
      label = _input$fields.label,
      _input$fields$max = _input$fields.max,
      max = _input$fields$max === void 0 ? 800 : _input$fields$max,
      _input$fields$min = _input$fields.min,
      min = _input$fields$min === void 0 ? 25 : _input$fields$min,
      name = _input$fields.name,
      _input$fields$step = _input$fields.step,
      step = _input$fields$step === void 0 ? 25 : _input$fields$step;

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue,
      values = _useFormikContext.values;

  var formattedValue = useCallback(function (value) {
    return format.replace(/\[\[value\]\]/g, value);
  }, [format]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionLabel, {
    info: info,
    infoIcon: infoIcon,
    label: label,
    openInfoDrawer: openInfoDrawer,
    required: isRequired
  }), /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    mt: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Slide to select")), /*#__PURE__*/React.createElement(CustomizedSlider, {
    "aria-labelledby": "discrete-slider",
    defaultValue: Number.parseInt(defaultValue, 10),
    getAriaValueText: formattedValue,
    name: name,
    marks: true,
    max: max,
    min: min,
    onChange: function onChange(event, value) {
      return setFieldValue(name, value);
    },
    step: step,
    values: values[name],
    valueLabelDisplay: "on",
    valueLabelFormat: formattedValue
  }));
}

DiscreteSlider.propTypes = {
  defaultValue: PropTypes.string,
  format: PropTypes.string,
  info: PropTypes.string,
  infoIcon: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  openInfoDrawer: PropTypes.func,
  step: PropTypes.number
};

var useStyles$q = makeStyles(function (_ref) {
  var _palette$dropdown, _palette$dropdown2;

  var palette = _ref.palette;
  return {
    root: {
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$dropdown = palette.dropdown) === null || _palette$dropdown === void 0 ? void 0 : _palette$dropdown.border,
        borderWidth: '2px'
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$dropdown2 = palette.dropdown) === null || _palette$dropdown2 === void 0 ? void 0 : _palette$dropdown2.border
      }
    }
  };
});

var Dropdown = function Dropdown(_ref2) {
  var doNotProceedContent = _ref2.doNotProceedContent,
      doNotProceedValues = _ref2.doNotProceedValues,
      info = _ref2.info,
      infoIcon = _ref2.infoIcon,
      input = _ref2.input,
      openInfoDrawer = _ref2.openInfoDrawer,
      sectionLabel = _ref2.sectionLabel;
  var _input$fields = input.fields,
      isRequired = _input$fields.isRequired,
      label = _input$fields.label,
      name = _input$fields.name,
      options = _input$fields.options,
      placeholder = _input$fields.placeholder;
  var classes = useStyles$q();

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      values = _useFormikContext.values,
      handleBlur = _useFormikContext.handleBlur,
      handleChange = _useFormikContext.handleChange,
      touched = _useFormikContext.touched;

  var handleClick = useCallback(function (e) {
    var _e$target;

    if (doNotProceedValues !== null && doNotProceedValues !== void 0 && doNotProceedValues.includes(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value)) {
      openInfoDrawer(doNotProceedContent, true);
    } else {
      handleChange(e);
    }
  }, [doNotProceedValues, handleChange, openInfoDrawer, doNotProceedContent]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionLabel, {
    info: info,
    infoIcon: infoIcon,
    label: sectionLabel,
    openInfoDrawer: openInfoDrawer,
    required: isRequired
  }), /*#__PURE__*/React.createElement(TextField, {
    className: classes.root,
    select: true,
    error: Boolean(touched[name] && errors[name]),
    fullWidth: true,
    helperText: touched[name] && errors[name] ? errors[name] : null,
    id: name,
    InputLabelProps: {
      shrink: true
    },
    label: label,
    name: name,
    onBlur: handleBlur,
    onChange: handleClick,
    placeholder: placeholder,
    required: isRequired,
    value: values[name],
    variant: "outlined"
  }, options.map(function (item) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: item.fields.value,
      key: item.sys.id
    }, item.fields.label);
  })));
};

Dropdown.propTypes = {
  info: PropTypes.string,
  infoIcon: PropTypes.object,
  input: PropTypes.object,
  openInfoDrawer: PropTypes.func,
  doNotProceedValues: PropTypes.array,
  doNotProceedContent: PropTypes.string,
  sectionLabel: PropTypes.string
};
Dropdown.defaultProps = {
  input: {},
  openInfoDrawer: function openInfoDrawer() {},
  doNotProceedValues: [],
  doNotProceedContent: ''
};

var HiddenInput = function HiddenInput(_ref) {
  var input = _ref.input;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      handleChange = _useFormikContext.handleChange,
      setFieldValue = _useFormikContext.setFieldValue;

  var name = input.fields.name; // format additionalInfo field

  useEffect(function () {
    if (name !== 'additional_info') return;
    var solarCustomer = "Currently has solar panels: ".concat(values.has_solar, "\n ");
    var energy_needs = "Energy Needs ".concat(values.energy_needs, "\n");
    var household_size = "Household Size: ".concat(values.household_size, "\n");
    var future_household_size = "Household Size: ".concat(values.future_household_size, "\n");
    var value = solarCustomer + energy_needs + household_size + future_household_size;
    setFieldValue(name, value);
  }, [name, setFieldValue, values]);
  return /*#__PURE__*/React.createElement(Input$1, {
    name: name,
    type: "hidden",
    className: "form-control",
    value: values[name],
    onChange: handleChange
  });
};

HiddenInput.propTypes = {
  input: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string
    })
  })
};

function NumberFormatter(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      other = _objectWithoutProperties(props, ["inputRef", "onChange"]);

  return /*#__PURE__*/React.createElement(NumberFormat, _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          name: props.name,
          value: values.value
        }
      });
    },
    thousandSeparator: true,
    isNumericString: true
  }));
}
NumberFormatter.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

var useStyles$p = makeStyles(function (_ref) {
  var _palette$input, _palette$input2;

  var palette = _ref.palette;
  return {
    root: {
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$input = palette.input) === null || _palette$input === void 0 ? void 0 : _palette$input.border,
        borderWidth: '2px'
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$input2 = palette.input) === null || _palette$input2 === void 0 ? void 0 : _palette$input2.border
      }
    }
  };
});

var Input = function Input(_ref2) {
  var input = _ref2.input;
  var _input$fields = input.fields,
      isRequired = _input$fields.isRequired,
      label = _input$fields.label,
      name = _input$fields.name,
      placeholder = _input$fields.placeholder,
      type = _input$fields.type;
  var classes = useStyles$p();

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      handleBlur = _useFormikContext.handleBlur,
      handleChange = _useFormikContext.handleChange,
      touched = _useFormikContext.touched,
      values = _useFormikContext.values;

  return /*#__PURE__*/React.createElement(TextField, {
    className: classes.root,
    error: Boolean(touched[name] && errors[name]),
    fullWidth: true,
    helperText: touched[name] && errors[name] ? errors[name] : null,
    id: name,
    InputLabelProps: {
      classes: {
        root: classes.root
      },
      shrink: true
    },
    InputProps: {
      inputComponent: type === 'number' ? NumberFormatter : 'input'
    },
    label: label,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    placeholder: placeholder,
    required: isRequired,
    type: "text",
    value: values[name],
    variant: "outlined"
  });
};

Input.propTypes = {
  input: PropTypes.object
};

var useStyles$o = makeStyles(function (theme) {
  return {
    box: _defineProperty({
      alignItems: 'center',
      border: function border(_ref) {
        var checked = _ref.checked,
            isActive = _ref.isActive;
        return isActive || checked ? '2px solid' : '1px solid';
      },
      borderRadius: 1,
      borderColor: function borderColor(_ref2) {
        var checked = _ref2.checked,
            isActive = _ref2.isActive;
        return checked || isActive ? theme.palette.radioIconButton.checked : theme.palette.radioIconButton.unchecked;
      },
      display: 'flex',
      flexDirection: 'column',
      height: 152,
      justifyContent: 'flex-end'
    }, theme.breakpoints.up('md'), {
      height: 224
    }),
    FormControlLabel: {
      fontSize: SIZE$1.s300,
      height: '100%',
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: '100%'
    },
    label: {
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s200
      }
    },
    icon: _defineProperty({
      height: 60,
      pointerEvents: 'none',
      position: 'absolute',
      width: 60,
      top: 25
    }, theme.breakpoints.up('md'), {
      height: 74,
      top: 52,
      width: 74
    })
  };
});

var RadioIconButton = function RadioIconButton(_ref3) {
  var _palette$radioIconBut, _palette$radioIconBut2, _palette$radioIconBut3, _palette$radioIconBut4;

  var checked = _ref3.checked,
      icon = _ref3.icon,
      handleClick = _ref3.handleClick,
      label = _ref3.label,
      value = _ref3.value;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var classes = useStyles$o({
    checked: checked,
    isActive: isActive
  });

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.box,
    onMouseEnter: function onMouseEnter() {
      setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      setActive(false);
    }
  }, icon && /*#__PURE__*/React.createElement("img", {
    src: icon[0].src,
    alt: icon[0].title,
    className: classes.icon,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.FormControlLabel,
    classes: {
      label: classes.label
    },
    onClick: function onClick() {
      handleClick(value);
    },
    control: /*#__PURE__*/React.createElement(Radio, {
      style: {
        color: isActive || checked ? palette === null || palette === void 0 ? void 0 : (_palette$radioIconBut = palette.radioIconButton) === null || _palette$radioIconBut === void 0 ? void 0 : _palette$radioIconBut.checked : palette === null || palette === void 0 ? void 0 : (_palette$radioIconBut2 = palette.radioIconButton) === null || _palette$radioIconBut2 === void 0 ? void 0 : _palette$radioIconBut2.unchecked
      }
    }),
    label: /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: '14px'
      }
    }, label),
    labelPlacement: "top",
    style: {
      color: isActive || checked ? palette === null || palette === void 0 ? void 0 : (_palette$radioIconBut3 = palette.radioIconButton) === null || _palette$radioIconBut3 === void 0 ? void 0 : _palette$radioIconBut3.checked : palette === null || palette === void 0 ? void 0 : (_palette$radioIconBut4 = palette.radioIconButton) === null || _palette$radioIconBut4 === void 0 ? void 0 : _palette$radioIconBut4.unchecked
    },
    value: value
  })));
};

RadioIconButton.propTypes = {
  checked: PropTypes.bool,
  handleClick: PropTypes.func,
  icon: PropTypes.array,
  label: PropTypes.string,
  value: PropTypes.string.isRequired
};
RadioIconButton.defaultProps = {
  handleClick: function handleClick() {},
  label: '',
  value: ''
};

var RadioIconOptions = function RadioIconOptions(_ref) {
  var doNotProceedContent = _ref.doNotProceedContent,
      doNotProceedValues = _ref.doNotProceedValues,
      info = _ref.info,
      infoIcon = _ref.infoIcon,
      input = _ref.input,
      openInfoDrawer = _ref.openInfoDrawer;
  var _input$fields = input.fields,
      isRequired = _input$fields.isRequired,
      label = _input$fields.label,
      name = _input$fields.name,
      options = _input$fields.options;

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      handleChange = _useFormikContext.handleChange,
      touched = _useFormikContext.touched,
      values = _useFormikContext.values;

  var selectedRadioButton = values[name];
  var handleClick = useCallback(function (e) {
    var _e$target;

    if (doNotProceedValues !== null && doNotProceedValues !== void 0 && doNotProceedValues.includes(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value)) {
      openInfoDrawer(doNotProceedContent, true);
    } else {
      handleChange(e);
    }
  }, [doNotProceedValues, handleChange, openInfoDrawer, doNotProceedContent]);
  return /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(SectionLabel, {
    info: info,
    infoIcon: infoIcon,
    label: label,
    openInfoDrawer: openInfoDrawer,
    required: isRequired
  }), touched[name] && errors[name] && /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, errors[name]), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    error: errors[name] ? true : null,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": name,
    defaultValue: selectedRadioButton,
    name: name,
    onChange: handleClick,
    row: true,
    value: selectedRadioButton
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "center",
    wrap: "nowrap",
    spacing: 1
  }, options === null || options === void 0 ? void 0 : options.map(function (option) {
    var _option$fields, _option$fields2, _option$fields3, _option$fields4, _option$sys;

    return /*#__PURE__*/React.createElement(RadioIconButton, {
      value: option === null || option === void 0 ? void 0 : (_option$fields = option.fields) === null || _option$fields === void 0 ? void 0 : _option$fields.value,
      label: option === null || option === void 0 ? void 0 : (_option$fields2 = option.fields) === null || _option$fields2 === void 0 ? void 0 : _option$fields2.label,
      icon: option === null || option === void 0 ? void 0 : (_option$fields3 = option.fields) === null || _option$fields3 === void 0 ? void 0 : _option$fields3.icon,
      handleClick: handleChange,
      checked: selectedRadioButton === (option === null || option === void 0 ? void 0 : (_option$fields4 = option.fields) === null || _option$fields4 === void 0 ? void 0 : _option$fields4.value),
      key: option === null || option === void 0 ? void 0 : (_option$sys = option.sys) === null || _option$sys === void 0 ? void 0 : _option$sys.id
    });
  })))));
};

RadioIconOptions.propTypes = {
  info: PropTypes.string,
  infoIcon: PropTypes.object,
  input: PropTypes.object,
  openInfoDrawer: PropTypes.func,
  doNotProceedValues: PropTypes.array,
  doNotProceedContent: PropTypes.string
};
RadioIconOptions.defaultProps = {
  input: {},
  openInfoDrawer: function openInfoDrawer() {},
  doNotProceedValues: [],
  doNotProceedContent: ''
};

var getActiveColor = function getActiveColor(_ref) {
  var _palette$stackedRadio, _palette$stackedRadio2;

  var checked = _ref.checked,
      isActive = _ref.isActive,
      palette = _ref.palette;
  return checked || isActive ? palette === null || palette === void 0 ? void 0 : (_palette$stackedRadio = palette.stackedRadioButton) === null || _palette$stackedRadio === void 0 ? void 0 : _palette$stackedRadio.checked : palette === null || palette === void 0 ? void 0 : (_palette$stackedRadio2 = palette.stackedRadioButton) === null || _palette$stackedRadio2 === void 0 ? void 0 : _palette$stackedRadio2.unchecked;
};

var useStyles$n = makeStyles(function (_ref2) {
  var palette = _ref2.palette;
  return {
    formControlLabel: {
      color: function color(_ref3) {
        var checked = _ref3.checked,
            isActive = _ref3.isActive;
        return "".concat(getActiveColor({
          checked: checked,
          isActive: isActive,
          palette: palette
        }), " !important");
      },
      width: '100%'
    },
    box: {
      borderColor: function borderColor(_ref4) {
        var checked = _ref4.checked,
            isActive = _ref4.isActive;
        return "".concat(getActiveColor({
          checked: checked,
          isActive: isActive,
          palette: palette
        }), " !important");
      }
    },
    radio: {
      color: function color(_ref5) {
        var checked = _ref5.checked,
            isActive = _ref5.isActive;
        return "".concat(getActiveColor({
          checked: checked,
          isActive: isActive,
          palette: palette
        }), " !important");
      }
    }
  };
});

var StackedRadioButton = function StackedRadioButton(_ref6) {
  var checked = _ref6.checked,
      handleClick = _ref6.handleClick,
      label = _ref6.label,
      value = _ref6.value;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var classes = useStyles$n({
    checked: checked,
    isActive: isActive
  });
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.box,
    border: checked || isActive ? 2 : 1,
    display: "flex",
    height: 60,
    mb: 1,
    onMouseEnter: function onMouseEnter() {
      setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      setActive(false);
    },
    pl: 3,
    width: 1
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.formControlLabel,
    control: /*#__PURE__*/React.createElement(Radio, {
      className: classes.radio
    }),
    label: label,
    onClick: function onClick() {
      handleClick(value);
    },
    value: value
  }));
};

StackedRadioButton.propTypes = {
  checked: PropTypes.bool,
  handleClick: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string.isRequired
};
StackedRadioButton.defaultProps = {
  checked: false,
  handleClick: function handleClick() {},
  label: '',
  value: ''
};

var StackedRadioOptions = function StackedRadioOptions(_ref) {
  var doNotProceedContent = _ref.doNotProceedContent,
      doNotProceedValues = _ref.doNotProceedValues,
      info = _ref.info,
      infoIcon = _ref.infoIcon,
      input = _ref.input,
      openInfoDrawer = _ref.openInfoDrawer;
  var _input$fields = input.fields,
      isRequired = _input$fields.isRequired,
      label = _input$fields.label,
      name = _input$fields.name,
      options = _input$fields.options;

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      handleChange = _useFormikContext.handleChange,
      touched = _useFormikContext.touched,
      values = _useFormikContext.values;

  var selectedRadioButton = values[name];
  var handleClick = useCallback(function (e) {
    var _e$target;

    if (doNotProceedValues !== null && doNotProceedValues !== void 0 && doNotProceedValues.includes(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value)) {
      openInfoDrawer(doNotProceedContent, true);
    } else {
      handleChange(e);
    }
  }, [doNotProceedValues, handleChange, openInfoDrawer, doNotProceedContent]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionLabel, {
    info: info,
    infoIcon: infoIcon,
    label: label,
    openInfoDrawer: openInfoDrawer,
    required: isRequired
  }), touched[name] && errors[name] && /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, errors[name]), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    error: Boolean(errors[name]),
    fullWidth: true
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": name,
    defaultValue: selectedRadioButton,
    name: name,
    onChange: handleClick,
    row: true,
    value: selectedRadioButton
  }, options.map(function (option) {
    var _option$fields, _option$fields2, _option$sys;

    return /*#__PURE__*/React.createElement(StackedRadioButton, {
      value: option === null || option === void 0 ? void 0 : (_option$fields = option.fields) === null || _option$fields === void 0 ? void 0 : _option$fields.value,
      label: option === null || option === void 0 ? void 0 : (_option$fields2 = option.fields) === null || _option$fields2 === void 0 ? void 0 : _option$fields2.label,
      handleClick: handleChange,
      checked: selectedRadioButton === option.fields.value,
      key: option === null || option === void 0 ? void 0 : (_option$sys = option.sys) === null || _option$sys === void 0 ? void 0 : _option$sys.id
    });
  }))));
};

StackedRadioOptions.propTypes = {
  info: PropTypes.string,
  infoIcon: PropTypes.object,
  input: PropTypes.object,
  openInfoDrawer: PropTypes.func,
  doNotProceedValues: PropTypes.array,
  doNotProceedContent: PropTypes.string
};
StackedRadioOptions.defaultProps = {
  input: {},
  openInfoDrawer: function openInfoDrawer() {},
  doNotProceedValues: [],
  doNotProceedContent: ''
};

var useStyles$m = makeStyles(function (_ref) {
  var _palette$telephoneInp, _palette$telephoneInp2;

  var palette = _ref.palette;
  return {
    root: {
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$telephoneInp = palette.telephoneInput) === null || _palette$telephoneInp === void 0 ? void 0 : _palette$telephoneInp.border,
        borderWidth: '2px'
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette === null || palette === void 0 ? void 0 : (_palette$telephoneInp2 = palette.telephoneInput) === null || _palette$telephoneInp2 === void 0 ? void 0 : _palette$telephoneInp2.border
      }
    }
  };
});

var TelephoneInput = function TelephoneInput(_ref2) {
  var input = _ref2.input;
  var classes = useStyles$m();

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      handleBlur = _useFormikContext.handleBlur,
      handleChange = _useFormikContext.handleChange,
      touched = _useFormikContext.touched,
      errors = _useFormikContext.errors;

  var _input$fields = input.fields,
      isRequired = _input$fields.isRequired,
      label = _input$fields.label,
      name = _input$fields.name,
      placeholder = _input$fields.placeholder,
      type = _input$fields.type;
  return /*#__PURE__*/React.createElement(InputMask, {
    value: values[name],
    onBlur: handleBlur,
    onChange: handleChange,
    mask: "\\(999\\) 999-9999"
  }, function (inputProps) {
    return /*#__PURE__*/React.createElement(TextField, {
      className: classes.root,
      placeholder: placeholder,
      error: Boolean(touched[name] && errors[name]),
      helperText: touched[name] && errors[name] ? errors[name] : null,
      InputLabelProps: {
        classes: {
          root: classes.root
        },
        shrink: true
      },
      fullWidth: true,
      id: name,
      label: label,
      name: name,
      required: isRequired,
      variant: "outlined",
      type: type
    });
  });
};

TelephoneInput.propTypes = {
  input: PropTypes.object
};

var TIME_INTERVAL = 15;
var useStyles$l = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      '& .MuiFormLabel-root.Mui-disabled': {
        color: "".concat(palette.text.disabled, " !important")
      },
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: function borderColor(_ref2) {
          var _palette$input;

          var disabled = _ref2.disabled;
          return !disabled && (palette === null || palette === void 0 ? void 0 : (_palette$input = palette.input) === null || _palette$input === void 0 ? void 0 : _palette$input.border);
        },
        borderWidth: '2px'
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: function borderColor(_ref3) {
          var _palette$input2;

          var disabled = _ref3.disabled;
          return !disabled && (palette === null || palette === void 0 ? void 0 : (_palette$input2 = palette.input) === null || _palette$input2 === void 0 ? void 0 : _palette$input2.border);
        }
      }
    }
  };
});
var dateName = 'scheduleCallDay'; // Day picker name from contentful

var TimePicker = function TimePicker(_ref4) {
  var disabled = _ref4.disabled,
      input = _ref4.input;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      dayHours = _useState2[0],
      setDayHours = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setValid = _useState4[1];

  var _input$fields = input.fields,
      label = _input$fields.label,
      name = _input$fields.name;
  var classes = useStyles$l({
    disabled: disabled
  });

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue,
      values = _useFormikContext.values;

  var handleChange = useCallback(function (e) {
    var date = values[dateName];
    var roundTime = roundToNearestMinutes(e, {
      nearestTo: TIME_INTERVAL
    });
    var newTime = format(roundTime, 'HH:mm');
    var isValidTime = isValidDateTime(date, newTime);
    var isValidToday = isValidTimeToday(date, newTime);
    var helperText = isValidToday ? getHelperTextForDay(Boolean(date) ? date : new Date()) : "Next available time today is: \n".concat(format(getNextTimeForToday(), 'hh:mm a', new Date()));
    setValid(isValidTime && isValidToday);
    setDayHours(helperText);
    setFieldValue(name, isValidTime && isValidToday ? newTime : null);
  }, [name, setFieldValue, values]);
  var timeValue = useMemo(function () {
    if (Boolean(values[name])) {
      return values[dateName] ? parse$1("".concat(values[dateName], "-").concat(values[name]), "".concat(DATE_FORMAT, "-").concat(TIME_FORMAT), new Date()) : parse$1("".concat(values[name]), TIME_FORMAT, new Date());
    }

    return null;
  }, [name, values]);
  useEffect(function () {
    var selectedDay = values['scheduleCallDay'];
    setDayHours(Boolean(selectedDay) ? getHelperTextForDay(selectedDay) : '');
  }, [name, values]);
  return /*#__PURE__*/React.createElement(TimePicker$1, {
    autoOk: true,
    className: classes.root,
    disabled: disabled,
    error: !isValid,
    helperText: dayHours,
    id: name,
    inputVariant: "outlined",
    label: label,
    minutesStep: TIME_INTERVAL,
    onChange: handleChange,
    onSelect: function onSelect(e) {
      return e.target.blur();
    },
    value: timeValue,
    variant: "inline"
  });
};

TimePicker.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.object
};

var _inputsMap;
var inputsMap = (_inputsMap = {}, _defineProperty(_inputsMap, options.ADDRESS_AUTOCOMPLETE, GoogleMaps), _defineProperty(_inputsMap, options.CHECKBOX, CheckboxOptions), _defineProperty(_inputsMap, options.DATEPICKER, DatePicker), _defineProperty(_inputsMap, options.HIDDEN, HiddenInput), _defineProperty(_inputsMap, options.RADIO_WITH_ICONS, RadioIconOptions), _defineProperty(_inputsMap, options.RADIO, StackedRadioOptions), _defineProperty(_inputsMap, options.SINGLE_SELECT_DROPDOWN, Dropdown), _defineProperty(_inputsMap, options.SLIDER, DiscreteSlider), _defineProperty(_inputsMap, options.TIMEPICKER, TimePicker), _defineProperty(_inputsMap, options.TELEPHONE, TelephoneInput), _inputsMap);

var AdvancedInput = function AdvancedInput(props) {
  var _props$input, _props$input$fields;

  var Component = inputsMap[(_props$input = props.input) === null || _props$input === void 0 ? void 0 : (_props$input$fields = _props$input.fields) === null || _props$input$fields === void 0 ? void 0 : _props$input$fields.type]; // Default to Input

  if (!Component) {
    Component = Input;
  }

  return /*#__PURE__*/React.createElement(Component, props);
};

AdvancedInput.propTypes = {
  input: PropTypes.object
};

var mapRenderers = function mapRenderers(_ref) {
  var isDarkBackground = _ref.isDarkBackground,
      markdownRenderers = _ref.renderers;
  return Object.keys(markdownRenderers).reduce(function (renderers, rendererName) {
    var Renderer = markdownRenderers[rendererName];
    return _objectSpread2(_objectSpread2({}, renderers), {}, _defineProperty({}, rendererName, function (props) {
      return /*#__PURE__*/React.createElement(Renderer, _extends({
        isDarkBackground: isDarkBackground
      }, props));
    }));
  }, {});
};

var useRenderers = function useRenderers(_ref) {
  var isDarkBackground = _ref.isDarkBackground,
      defaultRenderers = _ref.defaultRenderers,
      renderers = _ref.renderers;

  var _useState = useState(mapRenderers({
    isDarkBackground: isDarkBackground,
    renderers: _objectSpread2(_objectSpread2({}, defaultRenderers), renderers)
  })),
      _useState2 = _slicedToArray(_useState, 2),
      mappedRenderers = _useState2[0],
      setMappedRenderers = _useState2[1];

  useEffect(function () {
    setMappedRenderers(mapRenderers({
      isDarkBackground: isDarkBackground,
      renderers: _objectSpread2(_objectSpread2({}, defaultRenderers), renderers)
    }));
  }, [isDarkBackground, defaultRenderers, renderers]);
  return mappedRenderers;
};

var useStyles$k = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      color: function color(_ref2) {
        var _palette$heading, _palette$heading$text, _palette$heading2, _palette$heading2$tex;

        var isDarkBackground = _ref2.isDarkBackground;
        return isDarkBackground ? palette === null || palette === void 0 ? void 0 : (_palette$heading = palette.heading) === null || _palette$heading === void 0 ? void 0 : (_palette$heading$text = _palette$heading.text) === null || _palette$heading$text === void 0 ? void 0 : _palette$heading$text.dark : palette === null || palette === void 0 ? void 0 : (_palette$heading2 = palette.heading) === null || _palette$heading2 === void 0 ? void 0 : (_palette$heading2$tex = _palette$heading2.text) === null || _palette$heading2$tex === void 0 ? void 0 : _palette$heading2$tex.main;
      }
    }
  };
});

var Heading$1 = function Heading(_ref3) {
  var level = _ref3.level,
      className = _ref3.className,
      isDarkBackground = _ref3.isDarkBackground,
      props = _objectWithoutProperties(_ref3, ["level", "className", "isDarkBackground"]);

  var classes = useStyles$k({
    isDarkBackground: isDarkBackground
  });
  return /*#__PURE__*/React.createElement(Typography, _extends({
    className: classnames(classes.root, classes["h".concat(level)], className),
    variant: "h".concat(level),
    component: "h".concat(level)
  }, props));
};

Heading$1.propTypes = {
  className: PropTypes.string,
  isDarkBackground: PropTypes.bool,
  level: PropTypes.number
};

var useStyles$j = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      color: function color(_ref2) {
        var _palette$paragraph, _palette$paragraph2;

        var isDarkBackground = _ref2.isDarkBackground;
        return isDarkBackground ? palette === null || palette === void 0 ? void 0 : (_palette$paragraph = palette.paragraph) === null || _palette$paragraph === void 0 ? void 0 : _palette$paragraph.dark : palette === null || palette === void 0 ? void 0 : (_palette$paragraph2 = palette.paragraph) === null || _palette$paragraph2 === void 0 ? void 0 : _palette$paragraph2.main;
      },
      '& > a': {
        color: function color(_ref3) {
          var _palette$link, _palette$link2;

          var isDarkBackground = _ref3.isDarkBackground;
          return isDarkBackground ? palette === null || palette === void 0 ? void 0 : (_palette$link = palette.link) === null || _palette$link === void 0 ? void 0 : _palette$link.dark : palette === null || palette === void 0 ? void 0 : (_palette$link2 = palette.link) === null || _palette$link2 === void 0 ? void 0 : _palette$link2.main;
        },
        textDecoration: function textDecoration(_ref4) {
          var isDarkBackground = _ref4.isDarkBackground;
          return isDarkBackground ? 'underline' : 'none';
        }
      }
    },
    caption: {
      color: function color(_ref5) {
        var _palette$paragraph3, _palette$paragraph3$c, _palette$paragraph4, _palette$paragraph4$c;

        var isDarkBackground = _ref5.isDarkBackground;
        return isDarkBackground ? (_palette$paragraph3 = palette.paragraph) === null || _palette$paragraph3 === void 0 ? void 0 : (_palette$paragraph3$c = _palette$paragraph3.caption) === null || _palette$paragraph3$c === void 0 ? void 0 : _palette$paragraph3$c.dark : (_palette$paragraph4 = palette.paragraph) === null || _palette$paragraph4 === void 0 ? void 0 : (_palette$paragraph4$c = _palette$paragraph4.caption) === null || _palette$paragraph4$c === void 0 ? void 0 : _palette$paragraph4$c.main;
      }
    }
  };
});

var Paragraph = function Paragraph(_ref6) {
  var className = _ref6.className,
      isDarkBackground = _ref6.isDarkBackground,
      variant = _ref6.variant,
      props = _objectWithoutProperties(_ref6, ["className", "isDarkBackground", "variant"]);

  var classes = useStyles$j({
    isDarkBackground: isDarkBackground
  });
  return /*#__PURE__*/React.createElement(Typography$1, _extends({
    className: classnames(classes.root, classes[variant], className),
    variant: variant
  }, props));
};

Paragraph.propTypes = {
  className: PropTypes.string,
  isDarkBackground: PropTypes.bool,
  variant: PropTypes.string
};

var useStyles$i = makeStyles$1(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      color: palette.emphasis,
      fontFamily: 'inherit',
      fontSize: 'inherit',
      textDecoration: 'underline'
    }
  };
}); // leave isDarkBackground so it's not passed along in ...props

var Emphasis = function Emphasis(_ref2) {
  var className = _ref2.className;
      _ref2.isDarkBackground;
      var props = _objectWithoutProperties(_ref2, ["className", "isDarkBackground"]);

  var classes = useStyles$i();
  return /*#__PURE__*/React.createElement(Typography$1, _extends({
    className: classnames(classes.root, className),
    component: "span"
  }, props));
};

Emphasis.propTypes = {
  className: PropTypes.string,
  isDarkBackground: PropTypes.bool
};

var useStyles$h = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      color: function color(_ref2) {
        var _palette$link, _palette$link2;

        var isDarkBackground = _ref2.isDarkBackground;
        return isDarkBackground ? palette === null || palette === void 0 ? void 0 : (_palette$link = palette.link) === null || _palette$link === void 0 ? void 0 : _palette$link.dark : palette === null || palette === void 0 ? void 0 : (_palette$link2 = palette.link) === null || _palette$link2 === void 0 ? void 0 : _palette$link2.main;
      },
      textDecoration: 'none'
    }
  };
});

var Link = function Link(_ref3) {
  var className = _ref3.className,
      isDarkBackground = _ref3.isDarkBackground,
      props = _objectWithoutProperties(_ref3, ["className", "isDarkBackground"]);

  var classes = useStyles$h({
    isDarkBackground: isDarkBackground
  });
  return /*#__PURE__*/React.createElement(Link$1, _extends({
    className: classnames(classes.root, className)
  }, props));
};

Link.propTypes = {
  className: PropTypes.string,
  isDarkBackground: PropTypes.bool
};

var defaultRenderers = {
  heading: Heading$1,
  paragraph: Paragraph,
  emphasis: Emphasis,
  link: Link
};
var useStyles$g = makeStyles(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      '& hr': {
        border: "2px solid ".concat(palette.hr),
        margin: "".concat(spacing(3), "px 0"),
        width: '60px'
      },
      '& .side-by-side': {
        marginBottom: spacing(7),
        '& h4': _objectSpread2(_objectSpread2({}, typography.h4), {}, {
          margin: 0
        }),
        '& p': _objectSpread2(_objectSpread2({}, typography.body1), {}, {
          margin: 0
        }),
        '@media (min-width:600px)': {
          display: 'flex'
        },
        '& > div': {
          '@media (min-width:600px)': {
            flex: '0 0 50%'
          }
        },
        // image side
        '& > div:last-child': {
          display: 'none',
          '@media (min-width:600px)': {
            display: 'block',
            paddingLeft: spacing(4)
          }
        }
      }
    }
  };
});

var Markdown = function Markdown(_ref2) {
  var children = _ref2.children,
      isDarkBackground = _ref2.isDarkBackground,
      renderersProp = _ref2.renderers,
      markdownProps = _objectWithoutProperties(_ref2, ["children", "isDarkBackground", "renderers"]);

  var renderers = useRenderers({
    isDarkBackground: isDarkBackground,
    defaultRenderers: defaultRenderers,
    renderers: renderersProp
  });
  var classes = useStyles$g();
  if (!children) return null;
  return /*#__PURE__*/React.createElement(ReactMarkdown, _extends({
    className: classes.root,
    allowDangerousHtml: true,
    renderers: renderers
  }, markdownProps), children);
};

Markdown.propTypes = {
  children: PropTypes.any,
  isDarkBackground: PropTypes.bool,
  renderers: PropTypes.object
};

var useStyles$f = makeStyles$1(function (_ref) {
  var _palette$advancedInpu;

  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    body2: {
      marginTop: 20
    },
    grayBox: {
      background: palette === null || palette === void 0 ? void 0 : (_palette$advancedInpu = palette.advancedInputGroup) === null || _palette$advancedInpu === void 0 ? void 0 : _palette$advancedInpu.grayBox,
      padding: '24px 0 12px'
    },
    label: {
      marginBottom: spacing(4)
    },
    line: {
      width: '100%',
      '& hr': {
        marginTop: spacing(1.5)
      }
    },
    separationLabel: {
      padding: "0 ".concat(spacing(2), "px ").concat(spacing(4), "px")
    }
  };
});

var renderers$4 = function renderers(classes) {
  return {
    // eslint-disable-next-line react/prop-types
    paragraph: function paragraph(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        className: classes.body2
      }, children);
    }
  };
};

var AdvancedInputGroup = function AdvancedInputGroup(_ref3) {
  var _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? 'transparent' : _ref3$backgroundColor,
      bypassOption = _ref3.bypassOption,
      helperText = _ref3.helperText,
      inputs = _ref3.inputs,
      label = _ref3.label,
      _ref3$layout = _ref3.layout,
      layout = _ref3$layout === void 0 ? '1 input' : _ref3$layout,
      rest = _objectWithoutProperties(_ref3, ["backgroundColor", "bypassOption", "helperText", "inputs", "label", "layout"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      disabled = _useState2[0],
      setDisabled = _useState2[1];

  var classes = useStyles$f();

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue,
      values = _useFormikContext.values;

  useEffect(function () {
    var _values$name;

    if (!bypassOption) return;
    var bypassInput = bypassOption.fields.options[0];
    var _bypassOption$fields = bypassOption.fields,
        name = _bypassOption$fields.name,
        value = _bypassOption$fields.value;

    if (!values[name]) {
      var _bypassInput$fields;

      setFieldValue(name, value ? [value] : []);
      setDisabled(value === (bypassInput === null || bypassInput === void 0 ? void 0 : (_bypassInput$fields = bypassInput.fields) === null || _bypassInput$fields === void 0 ? void 0 : _bypassInput$fields.value));
      return;
    }

    setDisabled((_values$name = values[name]) === null || _values$name === void 0 ? void 0 : _values$name.includes(value));
  }, [bypassOption, setFieldValue, values]);
  return /*#__PURE__*/React.createElement(Box, {
    className: backgroundColor === 'dark gray' ? classes.grayBox : null
  }, label && /*#__PURE__*/React.createElement(Typography, {
    className: classes.label,
    variant: "h4"
  }, label), bypassOption && /*#__PURE__*/React.createElement(Box, {
    style: {
      marginTop: 0,
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(AdvancedInput, {
    key: bypassOption.sys.id,
    input: bypassOption,
    isBypass: true
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.line
  }, /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement(Typography, {
    className: classes.separationLabel,
    variant: "h5"
  }, "OR"), /*#__PURE__*/React.createElement("span", {
    className: classes.line
  }, /*#__PURE__*/React.createElement("hr", null)))), (inputs === null || inputs === void 0 ? void 0 : inputs.length) && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, inputs.map(function (input) {
    var _input$fields, _input$fields$input, _input$fields$input$f;

    return (input === null || input === void 0 ? void 0 : (_input$fields = input.fields) === null || _input$fields === void 0 ? void 0 : (_input$fields$input = _input$fields.input) === null || _input$fields$input === void 0 ? void 0 : (_input$fields$input$f = _input$fields$input.fields) === null || _input$fields$input$f === void 0 ? void 0 : _input$fields$input$f.type) === 'hidden' ? /*#__PURE__*/React.createElement(AdvancedInput, _extends({
      key: input.sys.id
    }, input.fields, {
      disabled: disabled
    })) : /*#__PURE__*/React.createElement(Grid, {
      key: input.sys.id,
      item: true,
      xs: layout === '1 input' ? 12 : 6
    }, /*#__PURE__*/React.createElement(AdvancedInput, _extends({}, input.fields, rest, {
      disabled: disabled
    })));
  })), helperText && /*#__PURE__*/React.createElement(Markdown, {
    renderers: renderers$4(classes)
  }, helperText));
};

AdvancedInputGroup.propTypes = {
  backgroundColor: PropTypes.string,
  bypassOption: PropTypes.object,
  helperText: PropTypes.string,
  inputs: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  layout: PropTypes.string
};

var useStyles$e = makeStyles(function (_ref) {
  var spacing = _ref.spacing;
  return {
    disclaimer: {
      marginTop: -spacing(2),
      '@media (min-width:960px)': {
        marginTop: -spacing(9)
      }
    }
  };
});

var renderers$3 = function renderers(classes) {
  return {
    // eslint-disable-next-line react/prop-types
    paragraph: function paragraph(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(Paragraph, {
        component: "p",
        variant: "caption",
        className: classnames('pageid-tcpa', classes.disclaimer)
      }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "leadid_tcpa_disclosure"
      }), children));
    }
  };
};

var Disclaimer = function Disclaimer(_ref3) {
  var primaryCopy = _ref3.primaryCopy;
  var classes = useStyles$e();
  return /*#__PURE__*/React.createElement(Markdown, {
    renderers: renderers$3(classes)
  }, primaryCopy);
};

Disclaimer.propTypes = {
  primaryCopy: PropTypes.string.isRequired
};

function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = _objectWithoutProperties(props, ["children", "value", "index"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: "simple-tabpanel-".concat(index),
    "aria-labelledby": "simple-tab-".concat(index)
  }, other), children);
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function Terms(props, styles) {
  var classes = props.classes,
      productType = props.productType,
      pricing = props.pricing;
  return /*#__PURE__*/React.createElement(Typography, {
    className: classes.terms,
    component: "div"
  }, productType === 'Monthly Lease' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.productType
  }, productType), /*#__PURE__*/React.createElement("div", {
    className: classes.hook
  }, "As little as")), productType !== 'Monthly Lease' && /*#__PURE__*/React.createElement("div", {
    className: classes.productType
  }, productType), /*#__PURE__*/React.createElement("div", {
    className: classes.pricing
  }, "$", pricing), /*#__PURE__*/React.createElement("div", {
    className: classes.upfrontCost
  }, "Upfront cost", productType !== 'Monthly Lease' && /*#__PURE__*/React.createElement("span", null, "^")));
}

Terms.propTypes = {
  classes: PropTypes.object,
  productType: PropTypes.string,
  pricing: PropTypes.string
};

function a11yProps(index) {
  return {
    id: "simple-tab-".concat(index),
    'aria-controls': "simple-tabpanel-".concat(index)
  };
}

function getPricing(leaseUpfrontCost, fullPurchasePrice, monthlyLoan, classes) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    bgcolor: "simpleTabs.leaseTabBackground",
    color: "simpleTabs.leaseTabText",
    display: "flex",
    justifyContent: "center",
    height: 30,
    mt: 3,
    p: 0,
    width: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, "Professionally managed by Sunrun"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    border: 1,
    bgcolor: "simpleTabs.tileBackground",
    borderTop: 0,
    borderColor: "simpleTabs.monthlyLeaseBorder",
    height: "100%",
    px: 0.5,
    py: 2
  }, /*#__PURE__*/React.createElement(Terms, {
    classes: classes,
    productType: "Monthly Lease",
    pricing: "0"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Box, {
    bgcolor: "simpleTabs.tileBackground",
    border: 1,
    borderLeft: 0,
    borderColor: "simpleTabs.tileBorder",
    height: "100%",
    px: 0.5,
    py: 2
  }, /*#__PURE__*/React.createElement(Terms, {
    classes: classes,
    productType: "Full Lease",
    pricing: leaseUpfrontCost
  })))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    bgcolor: "simpleTabs.tileBackground",
    borderColor: "simpleTabs.othePlansTabBorder",
    border: 1,
    display: "flex",
    justifyContent: "center",
    height: 30,
    mt: 3,
    p: 0,
    width: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, "You own & maintain the system"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Box, {
    bgcolor: "simpleTabs.tileBackground",
    border: 1,
    borderRight: 0,
    borderColor: "simpleTabs.tileBorder",
    height: "100%",
    px: 0.5,
    py: 2
  }, /*#__PURE__*/React.createElement(Terms, {
    classes: classes,
    productType: "Full Purchase",
    pricing: fullPurchasePrice
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Box, {
    bgcolor: "simpleTabs.tileBackground",
    border: 1,
    borderColor: "simpleTabs.tileBorder",
    px: 0.5,
    py: 2
  }, /*#__PURE__*/React.createElement(Terms, {
    classes: classes,
    productType: "Monthly Loan",
    pricing: monthlyLoan
  }))))));
}

var useStyles$d = makeStyles(function (_ref) {
  var _palette$simpleTabs, _typography$simpleTab, _typography$simpleTab2;

  var palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      flexGrow: 1
    },
    header: {
      backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$simpleTabs = palette.simpleTabs) === null || _palette$simpleTabs === void 0 ? void 0 : _palette$simpleTabs.headerBackground
    },
    title: {
      color: palette.header.text,
      fontSize: SIZE$1.s300,
      lineHeight: '1.071428571',
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s200
      }
    },
    terms: {
      textAlign: 'center'
    },
    productType: {
      fontSize: SIZE$1.s600,
      lineHeight: 'calc(22/18)',
      marginBottom: spacing(1.5),
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s300,
        lineHeight: 'calc(16/14)',
        marginBottom: spacing(3)
      }
    },
    pricing: {
      fontSize: SIZE$1.s800,
      fontFamily: typography === null || typography === void 0 ? void 0 : (_typography$simpleTab = typography.simpleTabsPricing) === null || _typography$simpleTab === void 0 ? void 0 : _typography$simpleTab.fontFamily,
      fontWeight: typography === null || typography === void 0 ? void 0 : (_typography$simpleTab2 = typography.simpleTabsPricing) === null || _typography$simpleTab2 === void 0 ? void 0 : _typography$simpleTab2.fontWeight,
      marginBottom: spacing(0.5),
      lineHeight: 'calc(32/22)',
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s600,
        lineHeight: '24px',
        marginBottom: spacing(1)
      }
    },
    upfrontCost: {
      fontSize: SIZE$1.s300,
      lineHeight: 'calc(18/14)',
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s200
      }
    },
    hook: {
      fontSize: SIZE$1.s200,
      marginBottom: spacing(0.5),
      marginTop: '-10px',
      '@media (min-width:1280px)': {
        marginTop: 0,
        position: 'absolute',
        top: 40,
        width: '100%'
      }
    }
  };
});
function SimpleTabs(props) {
  var tab = 0;

  switch (props.backup) {
    case 'essential':
    case 'complete':
    case 'unknown':
      tab = 0;
      break;

    case ' ':
      tab = 1;
      break;

    default:
      tab = 0;
  }

  var classes = useStyles$d();

  var _React$useState = React.useState(tab),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(AppBar, {
    bgcolor: "simpleTabs.appBarBackground",
    className: classes.header,
    color: "transparent",
    elevation: 0,
    position: "static"
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    variant: 'fullWidth',
    onChange: handleChange,
    "aria-label": "Pricing Tabs"
  }, /*#__PURE__*/React.createElement(Tab, _extends({
    disableRipple: true,
    label: "Battery Backup"
  }, a11yProps(0))), /*#__PURE__*/React.createElement(Tab, _extends({
    disableRipple: true,
    label: "Solar Only"
  }, a11yProps(1))))), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 0
  }, getPricing('17k - 34k', '24k - 44k', '28k - 55k', classes)), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 1
  }, getPricing('12k - 23k', '16k - 29k', '20k - 40k', classes)));
}
SimpleTabs.propTypes = {
  backup: PropTypes.string
};

var useStyles$c = makeStyles$1(function (_ref) {
  var _palette$sunrunLink, _palette$sunrunLink2, _palette$sunrunLink3, _palette$sunrunLink4, _palette$sunrunLink5;

  var palette = _ref.palette;
  return {
    root: {
      backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$sunrunLink = palette.sunrunLink) === null || _palette$sunrunLink === void 0 ? void 0 : _palette$sunrunLink.background,
      '&:hover': {
        backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$sunrunLink2 = palette.sunrunLink) === null || _palette$sunrunLink2 === void 0 ? void 0 : _palette$sunrunLink2.hover,
        textDecoration: 'none'
      },
      '&:focus': {
        backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$sunrunLink3 = palette.sunrunLink) === null || _palette$sunrunLink3 === void 0 ? void 0 : _palette$sunrunLink3.hover
      },
      borderRadius: (palette === null || palette === void 0 ? void 0 : (_palette$sunrunLink4 = palette.sunrunLink) === null || _palette$sunrunLink4 === void 0 ? void 0 : _palette$sunrunLink4.borderRadius) || 24,
      boxShadow: 'none',
      color: palette === null || palette === void 0 ? void 0 : (_palette$sunrunLink5 = palette.sunrunLink) === null || _palette$sunrunLink5 === void 0 ? void 0 : _palette$sunrunLink5.text,
      display: 'block',
      fontSize: SIZE$1.s500,
      height: 48,
      lineHeight: '3',
      minWidth: 190,
      textAlign: 'center',
      textDecoration: 'none'
    }
  };
});
function SunrunLink(_ref2) {
  var children = _ref2.children,
      href = _ref2.href;
  var classes = useStyles$c();
  return /*#__PURE__*/React.createElement(Link$2, {
    className: classes.root,
    href: href
  }, children);
}
SunrunLink.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string
};

var ContentContext = /*#__PURE__*/React.createContext({});

var renderers$2 = function renderers(classes) {
  return {
    heading: function heading(props) {
      return /*#__PURE__*/React.createElement(Box, {
        mb: 3
      }, /*#__PURE__*/React.createElement(Heading$1, _extends({
        align: "center",
        className: classes.heading
      }, props)));
    },
    // eslint-disable-next-line react/prop-types
    paragraph: function paragraph(_ref) {
      var children = _ref.children;
      return /*#__PURE__*/React.createElement(Box, {
        mb: 4
      }, /*#__PURE__*/React.createElement(Paragraph, {
        align: "center",
        component: "h5",
        variant: "h5",
        style: {
          fontSize: SIZE$1.s700
        }
      }, children));
    }
  };
};

var disclaimerRenderers = {
  // eslint-disable-next-line react/prop-types
  paragraph: function paragraph(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/React.createElement(Paragraph, {
      component: "p",
      variant: "caption"
    }, children);
  }
};
var useStyles$b = makeStyles(function (_ref3) {
  var _typography$thankYouH, _typography$thankYouH2;

  var typography = _ref3.typography;
  return {
    heading: {
      fontFamily: typography === null || typography === void 0 ? void 0 : (_typography$thankYouH = typography.thankYouHeading) === null || _typography$thankYouH === void 0 ? void 0 : _typography$thankYouH.fontFamily,
      fontSize: SIZE$1.s1000,
      fontWeight: typography === null || typography === void 0 ? void 0 : (_typography$thankYouH2 = typography.thankYouHeading) === null || _typography$thankYouH2 === void 0 ? void 0 : _typography$thankYouH2.fontWeight,
      lineHeight: 1
    }
  };
});
function RecommendationForm$1() {
  var _content$finalContent;

  var content = useContext(ContentContext);
  var finalContent = content === null || content === void 0 ? void 0 : (_content$finalContent = content.finalContent) === null || _content$finalContent === void 0 ? void 0 : _content$finalContent.fields;
  var classes = useStyles$b();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Markdown, {
    renderers: renderers$2(classes)
  }, finalContent.primaryCopy), /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(SunrunLink, {
    href: finalContent.cta.fields.action
  }, finalContent.cta.fields.text)), /*#__PURE__*/React.createElement(Box, {
    mb: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Link$1, {
    href: finalContent.secondaryCta.fields.action,
    color: "inherit"
  }, finalContent.secondaryCta.fields.text))), /*#__PURE__*/React.createElement(Markdown, {
    renderers: disclaimerRenderers
  }, finalContent.primarySmallText));
}

var useHeadingStyles = makeStyles(function (_ref) {
  var _palette$recommendati;

  var palette = _ref.palette;
  return {
    h5: {
      color: palette === null || palette === void 0 ? void 0 : (_palette$recommendati = palette.recommendation) === null || _palette$recommendati === void 0 ? void 0 : _palette$recommendati.h5
    }
  };
}); // eslint-disable-next-line react/prop-types

var Heading = function Heading(_ref2) {
  var children = _ref2.children,
      level = _ref2.level;
  var classes = useHeadingStyles();
  return /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h".concat(level),
    className: classes["h".concat(level)]
  }, children));
};

var useStyles$a = makeStyles(function () {
  return {
    figure: {
      margin: 0
    },
    caption: {
      fontSize: SIZE$1.s200,
      fontWeight: 400,
      lineHeight: 1.428571429,
      letterSpacing: '0.03333em'
    }
  };
});

var Figure = function Figure(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      src = _ref.src;
  var classes = useStyles$a();
  return /*#__PURE__*/React.createElement("figure", {
    className: classes.figure
  }, /*#__PURE__*/React.createElement("img", {
    component: "img",
    alt: alt,
    height: "130",
    src: src,
    title: alt
  }), /*#__PURE__*/React.createElement("figcaption", {
    className: classes.caption
  }, children));
};

Figure.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.any,
  src: PropTypes.string.isRequired
};

var LGChemBatteryImage = "data:image/png;base64,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";

var TeslaBatteryImage = "data:image/png;base64,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";

var BatteryImage = function BatteryImage(_ref) {
  var additionalServices = _ref.additionalServices;

  switch (additionalServices) {
    case 'essential':
      return /*#__PURE__*/React.createElement(Figure, {
        alt: "LG Chem battery",
        src: LGChemBatteryImage
      }, "Essential Home", /*#__PURE__*/React.createElement("br", null), "Backup with LG Chem");

    case 'complete':
    case 'unknown':
      return /*#__PURE__*/React.createElement(Figure, {
        alt: "Tesla Battery",
        src: TeslaBatteryImage
      }, "Complete Home Backup", /*#__PURE__*/React.createElement("br", null), "with Tesla Powerwall");

    default:
      return null;
  }
};

BatteryImage.propTypes = {
  additionalServices: PropTypes.string
};

var LGChemPanels = "data:image/png;base64,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";

var ImageLayout = function ImageLayout(_ref) {
  var additionalServices = _ref.additionalServices;
  var allowedSet = ['essential', 'unknown', 'complete'];
  var includesAdditionalServices = allowedSet.includes(additionalServices);
  var gridSize = includesAdditionalServices ? 6 : 12;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, includesAdditionalServices && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: gridSize
  }, /*#__PURE__*/React.createElement(Box, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(BatteryImage, {
    additionalServices: additionalServices
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: gridSize
  }, /*#__PURE__*/React.createElement(Box, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Figure, {
    alt: "LG Chem panels",
    src: LGChemPanels
  }, "Solar Panels", /*#__PURE__*/React.createElement("br", null), "by LG Chem"))));
};

ImageLayout.propTypes = {
  additionalServices: PropTypes.string
};

var renderers$1 = {
  heading: Heading
};

function RecommendationForm(_ref) {
  var primaryCopy = _ref.primaryCopy;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values;

  var additionalServices = values.additionalServices;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    bgcolor: "recommendation.background",
    border: 1,
    borderColor: "recommendation.border",
    color: "recommendation.text",
    mb: 2,
    px: {
      xs: 5
    },
    py: 4,
    width: 1
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: 504,
    mx: "auto"
  }, /*#__PURE__*/React.createElement(ImageLayout, {
    additionalServices: additionalServices
  }))), /*#__PURE__*/React.createElement(Box, {
    bgcolor: "recommendation.background",
    border: 1,
    borderColor: "recommendation.border",
    id: "pricing-box",
    mb: 3,
    pl: {
      xs: 4,
      lg: 2
    },
    pr: {
      xs: 3,
      lg: 2
    },
    py: 3,
    width: 1
  }, /*#__PURE__*/React.createElement(Markdown, {
    renderers: renderers$1
  }, primaryCopy), /*#__PURE__*/React.createElement(SimpleTabs, {
    backup: additionalServices
  })), /*#__PURE__*/React.createElement(Hidden, {
    mdUp: true
  }, /*#__PURE__*/React.createElement(Box, {
    bgcolor: "recommendation.thankyouBox",
    px: 5,
    py: 2
  }, /*#__PURE__*/React.createElement(RecommendationForm$1, null))));
}

RecommendationForm.propTypes = {
  primaryCopy: PropTypes.string
};

var cmsComponents = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Disclaimer: Disclaimer,
  Recommendation: RecommendationForm
});

var ComponentSwitcher = function ComponentSwitcher(_ref) {
  var componentModel = _ref.componentModel,
      props = _objectWithoutProperties(_ref, ["componentModel"]);

  var Component;

  switch (componentModel) {
    case 'advancedInput':
      Component = AdvancedInput;
      break;

    case 'advancedInputGroup':
      Component = AdvancedInputGroup;
      break;

    case 'markdown':
      Component = Markdown;
      props = {
        children: props.markdown
      };
      break;

    case 'section':
      Component = cmsComponents[props.componentType];
      break;

    default:
      return null;
  }

  return /*#__PURE__*/React.createElement(Component, props);
};

ComponentSwitcher.propTypes = {
  componentModel: PropTypes.string.isRequired,
  componentType: PropTypes.string,
  markdown: PropTypes.string
};

var ErrorMessages = function ErrorMessages(_ref) {
  var submitted = _ref.submitted;

  // Grab values and submitForm from context
  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      isValid = _useFormikContext.isValid,
      isSubmitting = _useFormikContext.isSubmitting;

  useEffect(function () {
    // scroll user to bottom of page so error messages are visible
    if (isValid || !isSubmitting) return;

    if (!isValid) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [isSubmitting, isValid, errors]);
  return submitted && /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    component: "div"
  }, Object.values(errors).map(function (error, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx
    }, " ", error);
  }));
};

ErrorMessages.propTypes = {
  submitted: PropTypes.bool
};

var sunrunUrl = 'https://www.sunrun.com';
var vivintUrl = 'https://www.vivintsolar.com';

var drawerWidth$2 = '75%';
var drawerWidthDesktop$2 = '488px';
var useStyles$9 = makeStyles(function (theme) {
  var _theme$palette, _theme$palette$infoDr;

  return {
    backArrow: {
      fill: theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$infoDr = _theme$palette.infoDrawer) === null || _theme$palette$infoDr === void 0 ? void 0 : _theme$palette$infoDr.arrow,
      fontSize: SIZE$1.s300
    },
    drawerPaper: _defineProperty({
      width: drawerWidth$2
    }, theme.breakpoints.up('md'), {
      width: drawerWidthDesktop$2
    }),
    button: {
      textDecoration: 'underline',
      fontSize: '16px'
    },
    text: {
      fontWeight: 600
    }
  };
});

var InfoDrawer = function InfoDrawer(_ref) {
  var isOpen = _ref.isOpen,
      isDisqualifying = _ref.isDisqualifying,
      onClose = _ref.onClose,
      content = _ref.content;
  var classes = useStyles$9();
  var goToHomePage = useCallback(function () {
    var _window, _window$location, _window$location$href;

    if (typeof window === 'undefined') return;
    var homeUrl = (_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && (_window$location$href = _window$location.href) !== null && _window$location$href !== void 0 && _window$location$href.includes('vivintsolar') ? vivintUrl : sunrunUrl;
    window.location = homeUrl;
  }, []);
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: 'right',
    classes: {
      paper: classes.drawerPaper
    },
    open: isOpen,
    variant: "temporary"
  }, /*#__PURE__*/React.createElement(Box, {
    pt: 4,
    pr: 4,
    pb: 4,
    pl: 6
  }, /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    onClick: isDisqualifying ? goToHomePage : onClose
  }, /*#__PURE__*/React.createElement(ArrowBackIosIcon, {
    className: classes.backArrow
  }), isDisqualifying ? 'Go to homepage' : 'Back'), /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    style: {
      margin: '20px 0'
    }
  }, /*#__PURE__*/React.createElement(Markdown, null, content)), isDisqualifying && /*#__PURE__*/React.createElement(Typography, {
    className: classes.text
  }, "Made a mistake?", /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.button,
    id: "back-button-info-panel"
  }, "Go Back"))));
};

InfoDrawer.propTypes = {
  isOpen: PropTypes.bool,
  isDisqualifying: PropTypes.bool,
  onClose: PropTypes.func,
  content: PropTypes.string
};

var CustomizedButton$1 = withStyles(function (_ref) {
  var _palette$button, _palette$button2, _palette$button3, _palette$button4;

  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      color: palette === null || palette === void 0 ? void 0 : (_palette$button = palette.button) === null || _palette$button === void 0 ? void 0 : _palette$button.text,
      backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$button2 = palette.button) === null || _palette$button2 === void 0 ? void 0 : _palette$button2.background,
      '&:hover, &:focus': {
        backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$button3 = palette.button) === null || _palette$button3 === void 0 ? void 0 : _palette$button3.hover
      },
      borderRadius: (palette === null || palette === void 0 ? void 0 : (_palette$button4 = palette.button) === null || _palette$button4 === void 0 ? void 0 : _palette$button4.borderRadius) || 24,
      boxShadow: 'none',
      fontSize: SIZE$1.s500,
      height: 60,
      lineHeight: '1.5',
      marginBottom: spacing(6),
      marginTop: spacing(3),
      minWidth: 190,
      '@media (min-width:960px)': {
        marginBottom: spacing(6),
        marginTop: spacing(3)
      }
    }
  };
})(Button);
function SunrunButton(_ref2) {
  var children = _ref2.children;

  var _useFormikContext = useFormikContext(),
      isSubmitting = _useFormikContext.isSubmitting;

  return /*#__PURE__*/React.createElement(CustomizedButton$1, {
    disabled: isSubmitting,
    disableRipple: true,
    variant: "contained",
    type: "submit",
    id: "nextButton"
  }, children);
}
SunrunButton.propTypes = {
  children: PropTypes.any
};

var useSteps = function useSteps() {
  var initialActiveStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var content = useContext(ContentContext);
  var steps = content.steps.map(function (step) {
    return _objectSpread2({
      id: step.sys.id
    }, step.fields);
  });

  var _useState = useState(initialActiveStep),
      _useState2 = _slicedToArray(_useState, 2),
      activeStepIndex = _useState2[0],
      setActiveStepIndex = _useState2[1];

  return {
    activeStepIndex: activeStepIndex,
    setActiveStepIndex: setActiveStepIndex,
    steps: steps
  };
};

var useStyles$8 = makeStyles({
  form: {
    paddingTop: 32,
    '@media (min-width: 960px)': {
      paddingTop: 144
    }
  }
});

var MainForm = function MainForm(_ref) {
  var activeStep = _ref.activeStep,
      setSubmitted = _ref.setSubmitted,
      submitted = _ref.submitted;
  var classes = useStyles$8();
  var content = useContext(ContentContext);

  var _useSteps = useSteps(activeStep),
      steps = _useSteps.steps; //Using new variables to keep the old components untouched


  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDisqualifying = _useState4[0],
      setDisqualifying = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      infoContent = _useState6[0],
      setInfoContent = _useState6[1];

  var _useFormikContext = useFormikContext(),
      handleSubmit = _useFormikContext.handleSubmit;

  var lastStepIndex = steps.length - 1;
  var activeStepContent = steps[activeStep];
  var openInfoDrawer = useCallback(function (content) {
    var isDQ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setDisqualifying(isDQ);
    setOpen(true);
    setInfoContent(content);
  }, []);
  var onCloseInfoDrawer = useCallback(function () {
    setOpen(false);
  }, []);
  var onSubmitHandler = useCallback(function (e) {
    setSubmitted(true);
    handleSubmit(e);
  }, [handleSubmit, setSubmitted]);
  return /*#__PURE__*/React.createElement(Form, {
    className: classnames(classes.form, 'product-selector-form'),
    autoComplete: "off",
    noValidate: true,
    onSubmit: onSubmitHandler
  }, /*#__PURE__*/React.createElement(InfoDrawer, {
    isOpen: open,
    onClose: onCloseInfoDrawer,
    content: infoContent,
    isDisqualifying: isDisqualifying
  }), activeStepContent.content.map(function (item) {
    var _item$sys, _item$sys$contentType, _item$sys$contentType2, _item$sys2, _item$sys3, _item$sys3$contentTyp, _item$sys3$contentTyp2;

    return (item === null || item === void 0 ? void 0 : (_item$sys = item.sys) === null || _item$sys === void 0 ? void 0 : (_item$sys$contentType = _item$sys.contentType) === null || _item$sys$contentType === void 0 ? void 0 : (_item$sys$contentType2 = _item$sys$contentType.sys) === null || _item$sys$contentType2 === void 0 ? void 0 : _item$sys$contentType2.id) && /*#__PURE__*/React.createElement(Box, {
      key: item === null || item === void 0 ? void 0 : (_item$sys2 = item.sys) === null || _item$sys2 === void 0 ? void 0 : _item$sys2.id,
      mb: {
        xs: 2,
        md: 9
      }
    }, /*#__PURE__*/React.createElement(ComponentSwitcher, _extends({
      componentModel: item === null || item === void 0 ? void 0 : (_item$sys3 = item.sys) === null || _item$sys3 === void 0 ? void 0 : (_item$sys3$contentTyp = _item$sys3.contentType) === null || _item$sys3$contentTyp === void 0 ? void 0 : (_item$sys3$contentTyp2 = _item$sys3$contentTyp.sys) === null || _item$sys3$contentTyp2 === void 0 ? void 0 : _item$sys3$contentTyp2.id
    }, item === null || item === void 0 ? void 0 : item.fields, {
      openInfoDrawer: openInfoDrawer
    })));
  }), /*#__PURE__*/React.createElement(ErrorMessages, {
    submitted: submitted
  }), activeStep < lastStepIndex && /*#__PURE__*/React.createElement(SunrunButton, null, activeStep === lastStepIndex - 1 ? content === null || content === void 0 ? void 0 : content.submitText : content === null || content === void 0 ? void 0 : content.nextText));
};

MainForm.propTypes = {
  activeStep: PropTypes.number,
  setSubmitted: PropTypes.func,
  submitted: PropTypes.bool
};

var moment = require('moment-timezone');

function advisorHours() {
  var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : moment().tz('America/Los_Angeles').day();
  var hour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment().tz('America/Los_Angeles').hour();
  // day should be 0 - 6, aka Sun - Sat
  // if it's greater than 6, it bubbles into the next week, e.g. 7 is Sunday of next week
  day = day % 7; //Advisor Hours
  // M-F 5am - 8pm
  // Sa 6am - 7pm
  // Su 7a - 4pm

  var advisorHours = day >= 1 && day <= 5 && hour >= 5 && hour < 21 || day === 6 && hour >= 6 && hour < 19 || day === 0 && hour >= 7 && hour < 16;
  return advisorHours;
}

var CustomizedButton = withStyles$1(function (_ref) {
  var _palette$chatButton, _palette$chatButton2, _palette$chatButton3, _palette$chatButton4, _palette$chatButton5;

  var palette = _ref.palette,
      spacing = _ref.spacing;
      _ref.typography;
  return {
    root: {
      color: palette === null || palette === void 0 ? void 0 : (_palette$chatButton = palette.chatButton) === null || _palette$chatButton === void 0 ? void 0 : _palette$chatButton.text,
      background: palette === null || palette === void 0 ? void 0 : (_palette$chatButton2 = palette.chatButton) === null || _palette$chatButton2 === void 0 ? void 0 : _palette$chatButton2.background,
      '&:hover': {
        backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$chatButton3 = palette.chatButton) === null || _palette$chatButton3 === void 0 ? void 0 : _palette$chatButton3.hover
      },
      '&:focus': {
        backgroundColor: palette === null || palette === void 0 ? void 0 : (_palette$chatButton4 = palette.chatButton) === null || _palette$chatButton4 === void 0 ? void 0 : _palette$chatButton4.hover
      },
      borderRadius: (palette === null || palette === void 0 ? void 0 : (_palette$chatButton5 = palette.chatButton) === null || _palette$chatButton5 === void 0 ? void 0 : _palette$chatButton5.borderRadius) || 24,
      fontSize: SIZE$1.s300,
      lineHeight: '1.5',
      marginBottom: spacing(12),
      marginTop: spacing(12),
      '@media (min-width:960px)': {
        marginBottom: spacing(6),
        marginTop: spacing(6)
      }
    }
  };
})(Button);
function ChatButton(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setVisibility = _useState2[1];

  useEffect(function () {
    var interval = setInterval(function () {
      if (advisorHours()) {
        setVisibility(true);
      } else {
        setVisibility(false);
      }
    }, 20 * 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [isVisible]);

  if (isVisible) {
    return /*#__PURE__*/React.createElement(Link$1, {
      onClick: function onClick() {
        window.open('https://home-c16.incontact.com/inContact/ChatClient/ChatClient.aspx?poc=c8bb6ed4-aaf9-4e91-9231-d4b53dd556c1&bu=4595152', 'pagename', 'resizable,height=503,width=503');
      }
    }, /*#__PURE__*/React.createElement(CustomizedButton, {
      variant: "contained",
      onClick: props.onClick
    }, props.children));
  } else {
    return null;
  }
}

var getLogoInfo = function getLogoInfo() {
  var _primaryMediaFile$fie, _primaryMediaFile$fie2, _primaryMediaFile$fie3, _primaryMediaFile$fie4, _primaryMediaFile$fie5, _primaryMediaFile$fie6, _primaryMediaFile$fie7, _primaryMediaFile$fie8;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fPrimaryMediaFile = _ref.fPrimaryMediaFile,
      primaryMediaFile = _ref.primaryMediaFile;

  var _ref2 = fPrimaryMediaFile || [],
      _ref3 = _slicedToArray(_ref2, 1),
      frontifyMediaFile = _ref3[0];

  if (frontifyMediaFile) {
    return {
      width: frontifyMediaFile.width,
      height: frontifyMediaFile.height,
      url: frontifyMediaFile.generic_url
    };
  }

  if (!primaryMediaFile) return;
  return {
    width: primaryMediaFile === null || primaryMediaFile === void 0 ? void 0 : (_primaryMediaFile$fie = primaryMediaFile.fields) === null || _primaryMediaFile$fie === void 0 ? void 0 : (_primaryMediaFile$fie2 = _primaryMediaFile$fie.file) === null || _primaryMediaFile$fie2 === void 0 ? void 0 : (_primaryMediaFile$fie3 = _primaryMediaFile$fie2.details) === null || _primaryMediaFile$fie3 === void 0 ? void 0 : _primaryMediaFile$fie3.width,
    height: primaryMediaFile === null || primaryMediaFile === void 0 ? void 0 : (_primaryMediaFile$fie4 = primaryMediaFile.fields) === null || _primaryMediaFile$fie4 === void 0 ? void 0 : (_primaryMediaFile$fie5 = _primaryMediaFile$fie4.file) === null || _primaryMediaFile$fie5 === void 0 ? void 0 : (_primaryMediaFile$fie6 = _primaryMediaFile$fie5.details) === null || _primaryMediaFile$fie6 === void 0 ? void 0 : _primaryMediaFile$fie6.height,
    url: "".concat(primaryMediaFile === null || primaryMediaFile === void 0 ? void 0 : (_primaryMediaFile$fie7 = primaryMediaFile.fields) === null || _primaryMediaFile$fie7 === void 0 ? void 0 : (_primaryMediaFile$fie8 = _primaryMediaFile$fie7.file) === null || _primaryMediaFile$fie8 === void 0 ? void 0 : _primaryMediaFile$fie8.url, "?w={width}")
  };
};

var HeaderContents = function HeaderContents(_ref4) {
  var _content$primaryConte, _primaryContent$cta, _primaryContent$cta$f, _primaryContent$cta2, _primaryContent$cta2$;

  var _ref4$activeStep = _ref4.activeStep,
      activeStep = _ref4$activeStep === void 0 ? 0 : _ref4$activeStep,
      toggleResponsiveDrawer = _ref4.toggleResponsiveDrawer;
  var content = useContext(ContentContext);
  var primaryContent = content === null || content === void 0 ? void 0 : (_content$primaryConte = content.primaryContent) === null || _content$primaryConte === void 0 ? void 0 : _content$primaryConte.fields;
  var logo = getLogoInfo(primaryContent);
  var LOGO_WIDTH = 105;
  var logoHeight = useMemo(function () {
    if (!(logo !== null && logo !== void 0 && logo.height) || !(logo !== null && logo !== void 0 && logo.width)) return null;
    var logoAspectRatio = logo.height / logo.width;
    return Math.round(logoAspectRatio * LOGO_WIDTH);
  }, [logo]);

  var _useSteps = useSteps(activeStep),
      steps = _useSteps.steps;

  var currentStep = steps[activeStep];
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Hidden, {
    mdUp: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    "aria-label": "menu",
    onClick: toggleResponsiveDrawer(true)
  }, /*#__PURE__*/React.createElement(MenuIcon, null))), logo && /*#__PURE__*/React.createElement(Link, {
    href: primaryContent === null || primaryContent === void 0 ? void 0 : (_primaryContent$cta = primaryContent.cta) === null || _primaryContent$cta === void 0 ? void 0 : (_primaryContent$cta$f = _primaryContent$cta.fields) === null || _primaryContent$cta$f === void 0 ? void 0 : _primaryContent$cta$f.action
  }, /*#__PURE__*/React.createElement("img", {
    alt: primaryContent === null || primaryContent === void 0 ? void 0 : (_primaryContent$cta2 = primaryContent.cta) === null || _primaryContent$cta2 === void 0 ? void 0 : (_primaryContent$cta2$ = _primaryContent$cta2.fields) === null || _primaryContent$cta2$ === void 0 ? void 0 : _primaryContent$cta2$.text,
    src: logo.url.replace('{width}', LOGO_WIDTH.toString()),
    width: LOGO_WIDTH,
    height: logoHeight
  }))), (currentStep === null || currentStep === void 0 ? void 0 : currentStep.info) && /*#__PURE__*/React.createElement(Box, {
    mx: 3,
    mb: 2,
    mt: {
      xs: 4,
      md: 20
    }
  }, /*#__PURE__*/React.createElement(Markdown, {
    isDarkBackground: true
  }, currentStep.info)));
};

HeaderContents.propTypes = {
  activeStep: PropTypes.number,
  toggleResponsiveDrawer: PropTypes.func
};

var useStyles$7 = makeStyles$1(function (_ref) {
  var _palette$header, _palette$header2;

  var palette = _ref.palette;
  return {
    appbar: {
      background: palette === null || palette === void 0 ? void 0 : (_palette$header = palette.header) === null || _palette$header === void 0 ? void 0 : _palette$header.background,
      height: '100%'
    },
    paper: {
      background: palette === null || palette === void 0 ? void 0 : (_palette$header2 = palette.header) === null || _palette$header2 === void 0 ? void 0 : _palette$header2.background,
      width: '25%'
    }
  };
});

function Header(props) {
  var _content$primaryConte, _primaryContent$secon, _primaryContent$secon2;

  var classes = useStyles$7();
  var content = useContext(ContentContext);
  var primaryContent = content === null || content === void 0 ? void 0 : (_content$primaryConte = content.primaryContent) === null || _content$primaryConte === void 0 ? void 0 : _content$primaryConte.fields;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(AppBar, {
    className: classes.appbar,
    position: "static"
  }, /*#__PURE__*/React.createElement(HeaderContents, props)), /*#__PURE__*/React.createElement(Hidden, {
    smDown: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement(Drawer, {
    classes: {
      paper: classes.paper
    },
    open: true,
    anchor: "left",
    className: classes.appbar,
    position: "static",
    height: "100%",
    variant: "permanent"
  }, /*#__PURE__*/React.createElement(HeaderContents, props), /*#__PURE__*/React.createElement(Box, {
    mx: 3,
    mt: 25,
    pb: 5
  }, (primaryContent === null || primaryContent === void 0 ? void 0 : primaryContent.primarySmallText) && /*#__PURE__*/React.createElement(Markdown, {
    isDarkBackground: true
  }, primaryContent.primarySmallText), /*#__PURE__*/React.createElement(ChatButton, null, (primaryContent === null || primaryContent === void 0 ? void 0 : (_primaryContent$secon = primaryContent.secondaryCta) === null || _primaryContent$secon === void 0 ? void 0 : (_primaryContent$secon2 = _primaryContent$secon.fields) === null || _primaryContent$secon2 === void 0 ? void 0 : _primaryContent$secon2.text) || 'Chat Now')))));
}

/**
 * Formatted list of inputs, grouped by step or flattened into single array
 */

function getAllInputSteps(steps) {
  var flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var inputSteps = steps.map(getInputStep);
  return flat ? flatten(inputSteps) : inputSteps;
}
/**
 * Returns a list of formatted inputs for a given step,
 */

function getInputStep(step) {
  var inputSteps = [];
  step.content.forEach(function (content) {
    var _content$sys, _content$sys$contentT, _content$sys$contentT2, _content$sys2, _content$sys2$content, _content$sys2$content2;

    if ((content === null || content === void 0 ? void 0 : (_content$sys = content.sys) === null || _content$sys === void 0 ? void 0 : (_content$sys$contentT = _content$sys.contentType) === null || _content$sys$contentT === void 0 ? void 0 : (_content$sys$contentT2 = _content$sys$contentT.sys) === null || _content$sys$contentT2 === void 0 ? void 0 : _content$sys$contentT2.id) === 'advancedInputGroup') {
      content.fields.inputs.forEach(function (input) {
        inputSteps.push(_objectSpread2({
          id: input.sys.id,
          stepId: step.id
        }, input.fields));
      });
    } else if ((content === null || content === void 0 ? void 0 : (_content$sys2 = content.sys) === null || _content$sys2 === void 0 ? void 0 : (_content$sys2$content = _content$sys2.contentType) === null || _content$sys2$content === void 0 ? void 0 : (_content$sys2$content2 = _content$sys2$content.sys) === null || _content$sys2$content2 === void 0 ? void 0 : _content$sys2$content2.id) === 'advancedInput') {
      inputSteps.push(_objectSpread2({
        id: content.sys.id,
        stepId: step.id
      }, content.fields));
    }
  });
  return inputSteps;
}
/**
 * Returns a formatted list of inputs which have progress text (format string for each step),
 * to be displayed in the VerticalStepper
 */

function getProgressSteps(steps) {
  var progressSteps = getAllInputSteps(steps, true).filter(function (step) {
    return step.progressText;
  });
  return progressSteps;
}

function getStepContent(values, progressSteps, stepId) {
  return progressSteps // only get content for the step we're on
  .filter(function (progressStep) {
    return progressStep.stepId === stepId;
  }).map(function (step) {
    var _step$input, _step$input$fields;

    // name is required on the input to get a value
    if (!(step !== null && step !== void 0 && (_step$input = step.input) !== null && _step$input !== void 0 && (_step$input$fields = _step$input.fields) !== null && _step$input$fields !== void 0 && _step$input$fields.name)) return null;
    var value = values[step.input.fields.name];
    if (!value) return null;
    if (typeof value === 'string' && !value.trim()) return null; // set text to format string from Contentful

    var text = step.progressText;

    if (step.progressText.includes('[[label]]')) {
      var label; // for options (i.e. radios, dropdowns) we need to find the selected option to get the label

      if (step.input.fields.options) {
        var selectedOption = step.input.fields.options.find(function (opt) {
          return opt.fields.value === value;
        });
        label = selectedOption.fields.label;
      } else {
        label = step.input.fields.label;
      }

      text = text.replace('[[label]]', label);
    }

    text = text.replace('[[value]]', value);
    return /*#__PURE__*/React.createElement(Typography, {
      key: step.id
    }, text);
  });
}

var useStyles$6 = makeStyles$1(function () {
  return {
    iconButton: {
      position: 'absolute',
      top: 0,
      right: 0
    },
    stepLabel: {
      position: 'relative'
    }
  };
});
function VerticalStepper(_ref) {
  var activeStep = _ref.activeStep,
      handleEdit = _ref.handleEdit;

  var _useSteps = useSteps(activeStep),
      steps = _useSteps.steps;

  var classes = useStyles$6();

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values;

  var progressSteps = getProgressSteps(steps);
  return /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    orientation: "vertical"
  }, steps.map(function (step, index) {
    if (!step.title) return null;
    return /*#__PURE__*/React.createElement(Step, {
      expanded: true,
      key: step.id
    }, /*#__PURE__*/React.createElement(StepLabel, {
      className: classes.stepLabel
    }, step.title, index <= activeStep - 1 && /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      disableRipple: true,
      className: classes.iconButton,
      onClick: function onClick() {
        handleEdit(index);
      }
    }, /*#__PURE__*/React.createElement(EditIcon, {
      fontSize: "small"
    }))), index <= activeStep && /*#__PURE__*/React.createElement(StepContent, null, getStepContent(values, progressSteps, step.id)));
  }));
}
VerticalStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  handleEdit: PropTypes.func.isRequired
};

var useStyles$5 = makeStyles$1(function (theme) {
  return {
    h3: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(2)
    }
  };
});

var renderers = function renderers(classes) {
  return {
    heading: function heading(props) {
      return /*#__PURE__*/React.createElement(Heading$1, _extends({
        className: classes.h3
      }, props));
    }
  };
};

var ResponsiveDrawerContent = function ResponsiveDrawerContent(_ref) {
  var _content$primaryConte, _content$primaryConte2;

  var activeStep = _ref.activeStep,
      handleEdit = _ref.handleEdit;
  var classes = useStyles$5();
  var content = useContext(ContentContext);

  var _useSteps = useSteps(activeStep),
      steps = _useSteps.steps;

  var lastStepIndex = steps.length - 1;

  if (activeStep === lastStepIndex) {
    return /*#__PURE__*/React.createElement(Box, {
      px: 4,
      py: 24
    }, /*#__PURE__*/React.createElement(RecommendationForm$1, null));
  }

  return /*#__PURE__*/React.createElement(Box, {
    id: "vertical-drawer",
    px: {
      xs: 5,
      md: 2
    },
    py: {
      xs: 10,
      md: 13
    }
  }, (content === null || content === void 0 ? void 0 : (_content$primaryConte = content.primaryContent) === null || _content$primaryConte === void 0 ? void 0 : (_content$primaryConte2 = _content$primaryConte.fields) === null || _content$primaryConte2 === void 0 ? void 0 : _content$primaryConte2.secondaryCopy) && /*#__PURE__*/React.createElement(Markdown, {
    renderers: renderers(classes)
  }, content.primaryContent.fields.secondaryCopy), /*#__PURE__*/React.createElement(VerticalStepper, {
    activeStep: activeStep,
    handleEdit: handleEdit
  }));
};

ResponsiveDrawerContent.propTypes = {
  activeStep: PropTypes.number,
  handleEdit: PropTypes.func
};

var useStyles$4 = makeStyles(function (_ref) {
  var _typography$footer, _typography$footerLin, _typography$footerLin2;

  var palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    footer: {
      padding: spacing(4),
      '& p': {
        fontSize: 12,
        fontWeight: typography === null || typography === void 0 ? void 0 : (_typography$footer = typography.footer) === null || _typography$footer === void 0 ? void 0 : _typography$footer.fontWeight,
        lineHeight: 1.25,
        marginBottom: spacing(1.75),
        textAlign: function textAlign(_ref2) {
          var rightAlign = _ref2.rightAlign;
          return rightAlign ? 'right' : 'left';
        }
      }
    },
    links: {
      '& a': {
        color: palette.text.primary
      },
      '& p': {
        fontFamily: typography === null || typography === void 0 ? void 0 : (_typography$footerLin = typography.footerLinks) === null || _typography$footerLin === void 0 ? void 0 : _typography$footerLin.fontFamily,
        fontWeight: typography === null || typography === void 0 ? void 0 : (_typography$footerLin2 = typography.footerLinks) === null || _typography$footerLin2 === void 0 ? void 0 : _typography$footerLin2.fontWeight
      }
    }
  };
});

var Footer = function Footer() {
  var _content$footer;

  var content = useContext(ContentContext);

  var _ref3 = (content === null || content === void 0 ? void 0 : (_content$footer = content.footer) === null || _content$footer === void 0 ? void 0 : _content$footer.fields) || {},
      primaryCopy = _ref3.primaryCopy,
      primarySmallText = _ref3.primarySmallText,
      secondarySmallText = _ref3.secondarySmallText;

  var year = new Date().getFullYear();
  var classes = useStyles$4({
    rightAlign: !!primarySmallText
  });
  return /*#__PURE__*/React.createElement("footer", {
    className: classes.footer
  }, primarySmallText && /*#__PURE__*/React.createElement(Markdown, null, primarySmallText.replace('[[year]]', year)), /*#__PURE__*/React.createElement(Markdown, {
    className: classes.links
  }, primaryCopy), secondarySmallText && /*#__PURE__*/React.createElement(Markdown, null, secondarySmallText.replace('[[year]]', year)));
};

var drawerWidth$1 = '95%';
var drawerWidthDesktop$1 = '25%';
var useStyles$3 = makeStyles$1(function (theme) {
  return {
    drawerPaper: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between',
      width: drawerWidth$1
    }, theme.breakpoints.up('md'), {
      width: drawerWidthDesktop$1
    }),
    closeIcon: {
      position: 'absolute',
      right: 20,
      top: 20
    }
  };
});

function ResponsiveDrawer(_ref) {
  var activeStep = _ref.activeStep,
      handleEdit = _ref.handleEdit,
      onClose = _ref.onClose,
      open = _ref.open;
  var classes = useStyles$3();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hidden, {
    smUp: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    classes: {
      paper: classes.drawerPaper
    },
    variant: "temporary",
    open: open
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: classes.closeIcon,
    onClick: onClose(false)
  }), /*#__PURE__*/React.createElement(ResponsiveDrawerContent, {
    activeStep: activeStep,
    handleEdit: handleEdit
  }), /*#__PURE__*/React.createElement(Footer, null))), /*#__PURE__*/React.createElement(Hidden, {
    smDown: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    classes: {
      paper: classes.drawerPaper
    },
    variant: "permanent",
    open: true
  }, /*#__PURE__*/React.createElement(ResponsiveDrawerContent, {
    activeStep: activeStep,
    handleEdit: handleEdit
  }), /*#__PURE__*/React.createElement(Footer, null))));
}

ResponsiveDrawer.propTypes = {
  activeStep: PropTypes.number,
  handleEdit: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

var STAGE = 'STAGE';
var PRODUCTION = 'PRODUCTION';
var environments = {
  STAGE: STAGE,
  PRODUCTION: PRODUCTION
};

var _FORM_URL;
var FORM_URL = (_FORM_URL = {}, _defineProperty(_FORM_URL, STAGE, 'https://staging.sunruntransit.com/proxy/lead'), _defineProperty(_FORM_URL, PRODUCTION, 'https://www.sunruntransit.com/proxy/lead'), _FORM_URL);

function validationSchema(currentStep) {
  var step = getInputStep(currentStep);
  var yupConfig = {};
  step.forEach(function (advancedInput) {
    var _advancedInput$input;

    var input = advancedInput === null || advancedInput === void 0 ? void 0 : (_advancedInput$input = advancedInput.input) === null || _advancedInput$input === void 0 ? void 0 : _advancedInput$input.fields; // Input must have name and be required to have schema validation

    if (!(input !== null && input !== void 0 && input.name) || !(input !== null && input !== void 0 && input.isRequired)) return;
    var inputConfig = (input === null || input === void 0 ? void 0 : input.type) === 'number' ? number().typeError('It must be a number').positive().integer() : string();
    inputConfig = inputConfig.required(input === null || input === void 0 ? void 0 : input.errorMessage);

    if ((input === null || input === void 0 ? void 0 : input.type) === 'email') {
      inputConfig = inputConfig.email('Invalid email address.');
    } else if ((input === null || input === void 0 ? void 0 : input.type) === 'tel') {
      inputConfig = inputConfig.phone('US', true, 'Please enter a valid phone number.');
    }

    yupConfig[input.name] = inputConfig;
  });
  return object().shape(yupConfig);
}

function getInitialValues(steps) {
  var initialValues = {
    ___pageid___: ''
  }; // Get all inputs with a name

  var allInputSteps = getAllInputSteps(steps, true).filter(function (step) {
    var _step$input, _step$input$fields;

    return step === null || step === void 0 ? void 0 : (_step$input = step.input) === null || _step$input === void 0 ? void 0 : (_step$input$fields = _step$input.fields) === null || _step$input$fields === void 0 ? void 0 : _step$input$fields.name;
  });
  allInputSteps.forEach(function (step) {
    var _step$input$fields2 = step.input.fields,
        defaultValue = _step$input$fields2.defaultValue,
        name = _step$input$fields2.name,
        type = _step$input$fields2.type,
        value = _step$input$fields2.value;
    var initValue = value || defaultValue || ''; // slider is a number

    if (type === 'slider' && defaultValue) {
      initValue = parseInt(defaultValue, 10);
    } // checkbox is an array of string values
    else if (type === 'Checkbox') {
        initValue = initValue === '' ? [] : initValue.split(',');
      }

    initialValues[name] = initValue;
  });
  return initialValues;
}

function getPageID() {
  var _document;

  var webUserID = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementsByName('___pageid___');
  return webUserID && webUserID[0] && webUserID[0].value ? webUserID[0].value : '';
}
function getleadID() {
  var _document2;

  var leadid = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.getElementsByName('universal_leadid');
  return leadid && leadid[0] && leadid[0].value ? leadid[0].value : '';
}
function getadBlockEnabled() {
  var _document3;

  var adBlockEnabled = (_document3 = document) === null || _document3 === void 0 ? void 0 : _document3.getElementsByName('adBlockEnabled');
  return adBlockEnabled && adBlockEnabled[0] && adBlockEnabled[0].value ? adBlockEnabled[0].value : null;
}
function getApplicationClientId() {
  var applicationClientId = Cookies.get('sr_client_id');
  return applicationClientId || null;
}
function getExperiementId() {
  var experimentID = Cookies.get('_gaexp');
  return experimentID || null;
}

function createDataLayer(step, name, value) {
  var dataLayer = {
    event: 'psform-field-complete',
    step: (step + 1).toString(),
    name: name
  };

  if (value !== undefined) {
    dataLayer.value = value;
  }

  return {
    dataLayer: dataLayer,
    dataLayerName: 'ProductSelector'
  };
}

function trackFormFields(step, values) {
  switch (step) {
    case 0:
      TagManager.dataLayer(createDataLayer(step, 'home address', 'completed'));
      TagManager.dataLayer(createDataLayer(step, 'home size', values.square_footage));
      TagManager.dataLayer(createDataLayer(step, 'home type', values.home_type));
      TagManager.dataLayer(createDataLayer(step, 'has solar', values.has_solar));
      TagManager.dataLayer(createDataLayer(step, 'roof pitch', values.roof_pitch));
      TagManager.dataLayer(createDataLayer(step, 'roof type', values.roof_type));
      break;

    case 1:
      TagManager.dataLayer(createDataLayer(step, 'avg electric bill', values.electric_bill_amnt));
      TagManager.dataLayer(createDataLayer(step, 'energy needs', values.energy_needs.toString()));
      TagManager.dataLayer(createDataLayer(step, 'household size', values.household_size));
      TagManager.dataLayer(createDataLayer(step, 'future household size', values.future_household_size));
      TagManager.dataLayer(createDataLayer(step, ' backup need', values.additionalServices));
      break;

    case 2:
      TagManager.dataLayer(createDataLayer(step, 'product interest', values.productInterest));
      TagManager.dataLayer(createDataLayer(step, 'credit score', values.credit_score));
      break;

    case 3:
      TagManager.dataLayer(createDataLayer(step, 'form fill'));
      break;

    default:
      return '';
  }
}

var EnvContext = /*#__PURE__*/React.createContext(STAGE);

function FormContainer() {
  var _useSteps = useSteps(0),
      activeStepIndex = _useSteps.activeStepIndex,
      steps = _useSteps.steps,
      setActiveStepIndex = _useSteps.setActiveStepIndex;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitted = _useState2[0],
      setSubmitted = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var currentValidationSchema = validationSchema(steps[activeStepIndex]);
  var isSubmitFormStep = activeStepIndex === steps.length - 2;
  var env = useContext(EnvContext);
  var initialValues = getInitialValues(steps);
  /* Server State Handling */

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      serverState = _useState6[0],
      setServerState = _useState6[1];

  var handleServerResponse = function handleServerResponse(ok, msg) {
    setServerState({
      ok: ok,
      msg: msg
    });
  };

  var handleEdit = function handleEdit(step) {
    setOpen(false);
    setActiveStepIndex(step);
  }; // ToggleResponsiveDrawer


  var toggleResponsiveDrawer = function toggleResponsiveDrawer(open) {
    return function (event) {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

      setOpen(open);
    };
  };

  function _sleep(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  }

  function _submitForm(_x, _x2) {
    return _submitForm2.apply(this, arguments);
  }

  function _submitForm2() {
    _submitForm2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, actions) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sleep(1000);

            case 2:
              _context.prev = 2;
              _context.next = 5;
              return axios({
                method: 'POST',
                url: FORM_URL[env],
                data: values,
                transformRequest: [function (data) {
                  var queryString = Object.keys(data).map(function (key) {
                    return key + '=' + data[key];
                  }).join('&');
                  return queryString;
                }]
              });

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              handleServerResponse(false, _context.t0.response.data.error);

            case 10:
              actions.setSubmitting(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 7]]);
    }));
    return _submitForm2.apply(this, arguments);
  }

  function handleOnSubmit(_x3, _x4) {
    return _handleOnSubmit.apply(this, arguments);
  }

  function _handleOnSubmit() {
    _handleOnSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values, actions) {
      var ___pageid___, universal_leadid, adBlockEnabled, Application_client_id__c, experiment_id, futureContactDateTime, doNotOverrideFutureContactDateTime, valuesToSend, additionalServices;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // add PageID to values
              ___pageid___ = getPageID();
              universal_leadid = getleadID();
              adBlockEnabled = getadBlockEnabled();
              Application_client_id__c = getApplicationClientId();
              experiment_id = getExperiementId();
              futureContactDateTime = getFutureContactDateTime(values['scheduleCallDay'], values['scheduleCallTime']);
              doNotOverrideFutureContactDateTime = true;
              valuesToSend = _objectSpread2(_objectSpread2({}, values), {}, {
                ___pageid___: ___pageid___,
                adBlockEnabled: adBlockEnabled,
                doNotOverrideFutureContactDateTime: doNotOverrideFutureContactDateTime,
                experiment_id: experiment_id,
                futureContactDateTime: futureContactDateTime,
                universal_leadid: universal_leadid,
                Application_client_id__c: Application_client_id__c
              }); // change additionalServices value if user choose battery backuup

              additionalServices = values.additionalServices;

              if (additionalServices === 'essential' || additionalServices === 'complete') {
                valuesToSend.additionalServices = 'Energy Storage / Bright Box Battery';
              }

              trackFormFields(activeStepIndex, values);

              if (isSubmitFormStep) {
                _submitForm(valuesToSend, actions);
              } else {
                setSubmitted(false);
                actions.setTouched({});
                actions.setSubmitting(false);
                window.scrollTo(0, 0);
              }

              setActiveStepIndex(activeStepIndex + 1);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handleOnSubmit.apply(this, arguments);
  }

  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: currentValidationSchema,
    onSubmit: handleOnSubmit
  }, function (props) {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 0,
      className: "step-".concat(activeStepIndex)
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 3
    }, /*#__PURE__*/React.createElement(Header, {
      activeStep: activeStepIndex,
      toggleResponsiveDrawer: toggleResponsiveDrawer
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6
    }, /*#__PURE__*/React.createElement(Container, null, serverState && /*#__PURE__*/React.createElement(Typography, {
      className: !serverState.ok ? 'error' : ''
    }, serverState.msg), /*#__PURE__*/React.createElement(Box, {
      maxWidth: 558,
      mx: "auto"
    }, /*#__PURE__*/React.createElement(MainForm, {
      activeStep: activeStepIndex,
      setSubmitted: setSubmitted,
      submitted: submitted
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 3
    }, /*#__PURE__*/React.createElement(ResponsiveDrawer, {
      activeStep: activeStepIndex,
      handleEdit: handleEdit,
      onClose: toggleResponsiveDrawer,
      open: open
    })));
  });
}

var useStyles$2 = makeStyles(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      background: function background(_ref2) {
        var _palette$typographySk;

        var _background = _ref2.background;
        return _background || (palette === null || palette === void 0 ? void 0 : (_palette$typographySk = palette.typographySkeleton) === null || _palette$typographySk === void 0 ? void 0 : _palette$typographySk.background);
      },
      height: function height(_ref3) {
        var _height = _ref3.height;
        return _height || SIZE$1.s500;
      },
      marginBottom: function marginBottom(_ref4) {
        var _marginBottom = _ref4.marginBottom;
        return _marginBottom || spacing(0.7);
      },
      marginTop: function marginTop(_ref5) {
        var _marginTop = _ref5.marginTop;
        return _marginTop;
      },
      width: function width(_ref6) {
        var _width = _ref6.width;
        return _width || '100%';
      }
    }
  };
});

var TypographySkeleton = function TypographySkeleton(props) {
  var classes = useStyles$2(props);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  });
};

TypographySkeleton.propTypes = {
  background: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var HeaderContentsSkeleton = function HeaderContentsSkeleton() {
  var _palette$header, _palette$heading, _palette$heading$text, _palette$header2;

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Hidden, {
    mdUp: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    "aria-label": "menu"
  }, /*#__PURE__*/React.createElement(MenuIcon, null))), /*#__PURE__*/React.createElement(TypographySkeleton, {
    background: palette === null || palette === void 0 ? void 0 : (_palette$header = palette.header) === null || _palette$header === void 0 ? void 0 : _palette$header.text,
    height: SIZE$1.s900,
    width: "82px"
  })), /*#__PURE__*/React.createElement(Box, {
    mx: 3,
    mb: 2,
    mt: {
      xs: 4,
      md: 20
    }
  }, /*#__PURE__*/React.createElement(TypographySkeleton, {
    background: palette === null || palette === void 0 ? void 0 : (_palette$heading = palette.heading) === null || _palette$heading === void 0 ? void 0 : (_palette$heading$text = _palette$heading.text) === null || _palette$heading$text === void 0 ? void 0 : _palette$heading$text.dark,
    height: SIZE$1.s1000,
    marginBottom: SIZE$1.s900
  }), /*#__PURE__*/React.createElement(TypographySkeleton, {
    background: palette === null || palette === void 0 ? void 0 : (_palette$header2 = palette.header) === null || _palette$header2 === void 0 ? void 0 : _palette$header2.text,
    height: 48
  })));
};

var useStyles$1 = makeStyles(function (_ref) {
  var _palette$header, _palette$header2;

  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    h3: {
      marginTop: '0',
      marginBottom: spacing(0.5),
      '@media (min-width:960px)': {
        marginTop: '0',
        marginBottom: spacing(2)
      }
    },
    appbar: {
      background: palette === null || palette === void 0 ? void 0 : (_palette$header = palette.header) === null || _palette$header === void 0 ? void 0 : _palette$header.background,
      height: '100%'
    },
    paper: {
      background: palette === null || palette === void 0 ? void 0 : (_palette$header2 = palette.header) === null || _palette$header2 === void 0 ? void 0 : _palette$header2.background,
      width: '25%'
    }
  };
});

var HeaderSkeleton = function HeaderSkeleton() {
  var _palette$header3;

  var classes = useStyles$1();

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBar, {
    className: classes.appbar,
    position: "static"
  }, /*#__PURE__*/React.createElement(HeaderContentsSkeleton, null)), /*#__PURE__*/React.createElement(Hidden, {
    smDown: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement(Drawer, {
    classes: {
      paper: classes.paper
    },
    open: true,
    anchor: "left",
    className: classes.appbar,
    position: "static",
    height: "100%",
    variant: "permanent"
  }, /*#__PURE__*/React.createElement(HeaderContentsSkeleton, null), /*#__PURE__*/React.createElement(Box, {
    mx: 3,
    mt: 25,
    pb: 5
  }, /*#__PURE__*/React.createElement(TypographySkeleton, {
    background: palette === null || palette === void 0 ? void 0 : (_palette$header3 = palette.header) === null || _palette$header3 === void 0 ? void 0 : _palette$header3.text,
    height: "46px",
    width: "220px"
  }), /*#__PURE__*/React.createElement(ChatButton, null, "Chat Now")))));
};

var drawerWidth = '95%';
var drawerWidthDesktop = '25%';
var useStyles = makeStyles$1(function (theme) {
  return {
    drawerPaper: _defineProperty({
      width: drawerWidth
    }, theme.breakpoints.up('md'), {
      width: drawerWidthDesktop
    }),
    closeIcon: {
      position: 'absolute',
      right: 20,
      top: 20
    }
  };
});

var ResponsiveDrawerSkeleton = function ResponsiveDrawerSkeleton() {
  var classes = useStyles();
  var theme = useTheme$1();
  return /*#__PURE__*/React.createElement(Hidden, {
    smDown: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    classes: {
      paper: classes.drawerPaper
    },
    variant: "permanent",
    open: true
  }, /*#__PURE__*/React.createElement(Box, {
    id: "vertical-drawer",
    px: {
      xs: 5,
      md: 2
    },
    py: {
      xs: 10,
      md: 13
    }
  }, /*#__PURE__*/React.createElement(TypographySkeleton, {
    width: "30%",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(6)
  }), /*#__PURE__*/React.createElement(Stepper, {
    activeStep: 0,
    orientation: "vertical"
  }, /*#__PURE__*/React.createElement(Step, {
    expanded: true
  }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(TypographySkeleton, {
    height: SIZE$1.s600,
    width: "30%"
  })))))));
};

var FormContainerSkeleton = function FormContainerSkeleton() {
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(HeaderSkeleton, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Box, {
    maxWidth: 558,
    mx: "auto"
  }, /*#__PURE__*/React.createElement(Box, {
    mb: {
      xs: 3,
      md: 7
    },
    mt: {
      xs: 4,
      md: 18
    }
  }, /*#__PURE__*/React.createElement(TypographySkeleton, {
    height: SIZE$1.s1000,
    marginBottom: SIZE$1.s900
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(ResponsiveDrawerSkeleton, null)));
};

var colors$1 = Object.freeze({
  blue: Object.freeze({
    light: '#0085FE',
    main: '#0073E0',
    dark: '#01193F'
  }),
  white: Object.freeze({
    main: '#FFFFFF'
  }),
  green: Object.freeze({
    main: '#038761'
  }),
  grey: Object.freeze({
    98: '#F5F5FA',
    88: '#D5D5E0',
    light: '#F9F9F9',
    main: '#8A8A99',
    dark: '#575766'
  }),
  yellow: Object.freeze({
    light: '##FFF4D8',
    main: '#FFDF88',
    dark: '#FFD35C'
  }),
  red: Object.freeze({
    main: '#E15554'
  })
});
var componentsColors = {
  button: {
    text: colors$1.blue.dark,
    background: colors$1.yellow.main,
    hover: colors$1.yellow.dark
  },
  chatButton: {
    text: colors$1.white.main,
    background: "linear-gradient(180deg, ".concat(colors$1.blue.light, " 0%, #0156FF 100%);"),
    hover: colors$1.yellow.dark
  },
  emphasis: colors$1.green.main,
  header: {
    background: colors$1.blue.dark,
    text: colors$1.white.main
  },
  heading: {
    text: {
      main: colors$1.blue.dark,
      dark: colors$1.yellow.main
    }
  },
  hr: colors$1.yellow.main,
  infoDrawer: {
    arrow: colors$1.blue.dark
  },
  link: {
    main: colors$1.blue.main,
    dark: colors$1.white.main
  },
  paragraph: {
    main: colors$1.blue.dark,
    dark: colors$1.white.main,
    caption: {
      main: colors$1.grey.dark,
      dark: colors$1.grey[98]
    }
  },
  sunrunLink: {
    text: colors$1.blue.dark,
    background: colors$1.yellow.main,
    hover: colors$1.yellow.dark
  },
  // input components
  addressAutocomplete: {
    icon: colors$1.grey.main,
    border: colors$1.blue.main,
    body2: colors$1.grey.main
  },
  advancedInputGroup: {
    grayBox: colors$1.grey[98]
  },
  checkboxButton: {
    background: colors$1.blue.main,
    border: {
      checked: colors$1.blue.main,
      unchecked: colors$1.blue.dark
    },
    text: {
      checked: colors$1.white.main,
      unchecked: colors$1.blue.dark
    }
  },
  dropdown: {
    border: colors$1.blue.main
  },
  input: {
    border: colors$1.blue.main
  },
  radioIconButton: {
    checked: colors$1.blue.main,
    unchecked: colors$1.blue.dark
  },
  stackedRadioButton: {
    checked: colors$1.blue.main,
    unchecked: colors$1.blue.dark
  },
  telephoneInput: {
    border: colors$1.blue.main
  },
  // end of input components
  recommendation: {
    background: colors$1.grey.light,
    border: colors$1.grey[88],
    h5: colors$1.grey.dark,
    text: colors$1.blue.dark,
    thankyouBox: colors$1.white.main
  },
  simpleTabs: {
    headerBackground: colors$1.white.main,
    appBarBackground: colors$1.white.main,
    cashTileBackground: colors$1.white.main,
    leaseTabBackground: colors$1.blue.dark,
    leaseTabText: colors$1.white.main,
    leaseTypeBackground: colors$1.white.main,
    monthlyLeaseBorder: colors$1.blue.dark,
    fullLeaseBorder: colors$1.grey[98],
    othePlansTabBorder: colors$1.grey[98],
    tileBackground: colors$1.white.main,
    tileBorder: colors$1.grey[98]
  },
  typographySkeleton: {
    background: colors$1.blue.dark
  }
};
var sunrunOptions = {
  palette: _objectSpread2({
    primary: {
      main: colors$1.blue.main
    },
    secondary: {
      main: colors$1.blue.dark
    },
    brand: {
      main: colors$1.blue.main
    },
    error: {
      main: colors$1.red.main
    }
  }, componentsColors),
  overrides: {
    MuiFormControl: {
      root: {
        '&:hover .MuiInputLabel-outlined': {
          color: colors$1.blue.main
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: colors$1.grey.main,
        '&.Mui-error': {
          color: colors$1.red.main
        }
      }
    },
    MuiInputLabel: {
      outlined: {
        color: colors$1.blue.dark,
        '&.Mui-focused': {
          color: colors$1.blue.main
        }
      }
    },
    MuiRadio: {
      root: {
        color: colors$1.blue.dark
      }
    },
    MuiTabs: {
      indicator: {
        backgroundColor: colors$1.yellow.dark
      }
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: colors$1.blue.dark
      }
    }
  }
};

var colors = Object.freeze({
  blue: Object.freeze({
    main: '#219CCE',
    dark: colors$1.blue.dark
  }),
  orange: Object.freeze({
    main: '#FF8200',
    dark: '#EB8113'
  }),
  white: Object.freeze({
    main: colors$1.white.main
  })
});
var buttonStyles = Object.freeze({
  text: colors.white.main,
  background: colors.orange.dark,
  hover: colors.orange.main,
  borderRadius: 4
});
var FONT_FAMILY$1 = '"Int Circular Pro 3"';
var FONT_WEIGHT_BOOK = 300;
var FONT_WEIGHT_MEDIUM = 500;
var vivintSolarOptions = {
  typography: {
    fontFamily: FONT_FAMILY$1,
    htmlFontSize: 10,
    caption: {
      fontWeight: FONT_WEIGHT_BOOK
    },
    h1: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    h3: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    h4: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    h5: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    body2: {
      fontWeight: FONT_WEIGHT_BOOK
    },
    button: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_BOOK
    },
    // custom
    addressAutocompleteLabel: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_BOOK
    },
    footer: {
      fontWeight: FONT_WEIGHT_BOOK
    },
    footerLinks: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_MEDIUM
    },
    simpleTabsPricing: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_BOOK
    },
    thankYouHeading: {
      fontFamily: FONT_FAMILY$1,
      fontWeight: FONT_WEIGHT_BOOK
    }
  },
  palette: {
    primary: {
      main: colors.blue.main
    },
    brand: {
      main: colors.blue.main
    },
    button: buttonStyles,
    chatButton: buttonStyles,
    emphasis: colors.blue.main,
    heading: {
      text: {
        main: colors.blue.dark,
        dark: colors.white.main
      }
    },
    sunrunLink: buttonStyles,
    // input components
    addressAutocomplete: {
      border: colors.blue.main
    },
    checkboxButton: {
      background: colors.blue.main,
      border: {
        checked: colors.blue.main
      }
    },
    dropdown: {
      border: colors.blue.main
    },
    input: {
      border: colors.blue.main
    },
    radioIconButton: {
      checked: colors.blue.main
    },
    stackedRadioButton: {
      checked: colors.blue.main
    },
    telephoneInput: {
      border: colors.blue.main
    }
  },
  overrides: {
    MuiButton: {
      label: {
        fontFamily: FONT_FAMILY$1
      },
      root: {}
    },
    MuiFormControlLabel: {
      label: {
        fontFamily: FONT_FAMILY$1,
        fontWeight: FONT_WEIGHT_BOOK
      }
    },
    MuiFormLabel: {
      root: {
        fontFamily: FONT_FAMILY$1,
        fontWeight: FONT_WEIGHT_BOOK
      }
    },
    MuiTab: {
      root: {
        fontFamily: FONT_FAMILY$1
      }
    }
  }
};
var vivintSolarOptions$1 = merge({}, sunrunOptions, vivintSolarOptions);

var FONT_FAMILY = 'UntitledSans';
var FONT_FAMILY_LIGHT = 'UntitledSansLight';
var FONT_FAMILY_MEDIUM = 'UntitledSansMedium';
var FONT_FAMILY_SERIF = 'UntitledSerif';
var themeOptions = {
  typography: {
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    caption: {
      lineHeight: '1.333333333',
      fontSize: SIZE$1.s200
    },
    h1: {
      fontFamily: FONT_FAMILY_MEDIUM,
      fontSize: SIZE$1.s900,
      lineHeight: 1.33,
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s1000
      }
    },
    h3: {
      fontFamily: FONT_FAMILY_MEDIUM,
      fontSize: SIZE$1.s900,
      lineHeight: '1.33',
      // 24/32px
      letterSpacing: '-1px',
      marginBottom: SIZE$1.s900,
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s1000,
        lineHeight: '1.25' // 32/40px

      }
    },
    h4: {
      fontSize: SIZE$1.s600,
      lineHeight: '1.333333333',
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s900
      }
    },
    h5: {
      fontSize: SIZE$1.s600,
      lineHeight: '1.22222',
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s700,
        lineHeight: '1.22222'
      }
    },
    body1: {
      fontSize: SIZE$1.s500,
      lineHeight: 1.5
    },
    body2: {
      lineHeight: '1.285714286'
    },
    button: {
      fontFamily: FONT_FAMILY_MEDIUM,
      fontSize: SIZE$1.s300,
      lineHeight: '1.142857143',
      // 14/16px
      '@media (min-width:960px)': {
        fontSize: SIZE$1.s600
      }
    },
    // custom
    addressAutocompleteLabel: {
      fontFamily: FONT_FAMILY
    },
    footerLinks: {
      fontFamily: FONT_FAMILY_MEDIUM
    },
    simleTabsPricing: {
      fontFamily: FONT_FAMILY_SERIF
    },
    thankYouHeading: {
      fontFamily: FONT_FAMILY
    }
  },
  spacing: 8,
  overrides: {
    MuiButton: {
      label: {
        textTransform: 'initial'
      },
      root: {
        borderRadius: '0'
      }
    },
    MuiCssBaseline: {
      '@global': {
        html: {
          WebkitFontSmoothing: 'auto'
        }
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: SIZE$1.s500
      }
    },
    MuiFormControlLabel: {
      label: {
        fontFamily: FONT_FAMILY,
        lineHeight: 1.2,
        '@media (min-width:600px)': {
          fontSize: SIZE$1.s700
        }
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: SIZE$1.s500,
        fontFamily: FONT_FAMILY_LIGHT,
        lineHeight: '1.333',
        marginBottom: SIZE$1.s800
      }
    },
    MuiInputBase: {
      root: {
        borderRadius: 1,
        fontSize: SIZE$1.s500,
        gap: SIZE$1.s100,
        height: 60,
        lineHeight: '1.5'
      }
    },
    MuiLink: {
      underlineHover: {
        '&:hover': {
          textDecoration: 'none'
        }
      }
    },
    MuiStepLabel: {
      label: {
        fontSize: SIZE$1.s600,
        lineHeight: '1.6',
        '@media (min-width:960px)': {
          fontSize: SIZE$1.s700,
          lineHeight: '1.6'
        },
        '&$active': {
          fontWeight: '400'
        }
      }
    },
    MuiTab: {
      root: {
        fontFamily: FONT_FAMILY,
        fontSize: SIZE$1.s400,
        textTransform: 'capitalize'
      }
    },
    MuiTextField: {
      root: {
        marginBottom: SIZE$1.s500
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 0
      }
    },
    MuiStepper: {
      root: {
        paddingTop: 0
      }
    },
    textField: {
      marginLeft: SIZE$1.s1000,
      marginRight: SIZE$1.s1000
    }
  }
};
var sunrunTheme = createMuiTheme(merge({}, themeOptions, sunrunOptions));
var vivintsolarTheme = createMuiTheme(merge({}, themeOptions, vivintSolarOptions$1));
var theme = {
  sunrun: sunrunTheme,
  'vivint solar': vivintsolarTheme
};

/* globals lm */
function loadZeusAnalytics(loadedRef) {
  // fail fast
  if (typeof window === 'undefined' || typeof document === 'undefined' || loadedRef.current || window.location.hostname === 'product.selector') {
    return;
  }

  if (document.querySelector('input[name="___pageid___"]')) {
    loadedRef.current = true;
    return;
  }

  (function (a, b, c, d, e) {
    a.LandingManObject = e;

    a[e] = a[e] || function () {
      (a[e].q = a[e].q || []).push(arguments);
    };

    a[e].l = 1 * new Date();
    var f = b.createElement(c),
        g = b.getElementsByTagName(c)[0];
    f.id = e;
    f.async = 1;
    f.src = d;
    g.parentNode.insertBefore(f, g);
  })(window, document, 'script', '//www.sunruntransit.com/proxy/analytics.js', 'lm');

  lm('initialize', {
    base_url: 'www.sunruntransit.com',
    debug: true
  });
  lm('session');
  lm('pageid');
  loadedRef.current = true;
}

var App = function App(_ref) {
  var content = _ref.content,
      _ref$env = _ref.env,
      env = _ref$env === void 0 ? STAGE : _ref$env,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading;
  var loaded = useRef(false);
  useEffect(function () {
    !isLoading && loadZeusAnalytics(loaded);
  }, [isLoading]);

  var _useState = useState(theme[content === null || content === void 0 ? void 0 : content.theme] || theme.sunrun),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTheme = _useState2[0],
      setSelectedTheme = _useState2[1];

  useEffect(function () {
    setSelectedTheme(theme[content === null || content === void 0 ? void 0 : content.theme] || theme.sunrun);
  }, [content === null || content === void 0 ? void 0 : content.theme]);
  if (isLoading) return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: selectedTheme
  }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(FormContainerSkeleton, null));
  return /*#__PURE__*/React.createElement(EnvContext.Provider, {
    value: env
  }, /*#__PURE__*/React.createElement(ContentContext.Provider, {
    value: content
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: selectedTheme
  }, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(FormContainer, null)))));
};

App.propTypes = {
  content: PropTypes.shape({
    theme: PropTypes.string
  }),
  env: PropTypes.string,
  isLoading: PropTypes.bool
};

export { App as ProductSelector, environments };
